"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "cal-root" };
var _hoisted_2 = { class: "cal-topbar" };
var _hoisted_3 = { class: "cal-role-row" };
var _hoisted_4 = { class: "cal-field cal-field-narrow" };
var _hoisted_5 = {
    key: 0,
    class: "cal-readonly-field"
};
var _hoisted_6 = ["value"];
var _hoisted_7 = { class: "cal-fields-row" };
var _hoisted_8 = {
    key: 0,
    class: "cal-field"
};
var _hoisted_9 = ["label"];
var _hoisted_10 = ["value"];
var _hoisted_11 = { class: "cal-field" };
var _hoisted_12 = {
    key: 0,
    class: "cal-readonly-field"
};
var _hoisted_13 = ["value"];
var _hoisted_14 = { class: "cal-field" };
var _hoisted_15 = { class: "cal-readonly-field" };
var _hoisted_16 = { class: "cal-field" };
var _hoisted_17 = ["disabled"];
var _hoisted_18 = ["value"];
var _hoisted_19 = ["disabled"];
var _hoisted_20 = { class: "cal-body" };
var _hoisted_21 = { class: "cal-rail" };
var _hoisted_22 = { class: "cal-card" };
var _hoisted_23 = {
    key: 0,
    class: "cal-person"
};
var _hoisted_24 = { class: "cal-person-name" };
var _hoisted_25 = { class: "cal-person-sub" };
var _hoisted_26 = {
    key: 1,
    class: "cal-card-empty"
};
var _hoisted_27 = { class: "cal-status-value" };
var _hoisted_28 = { class: "cal-card" };
var _hoisted_29 = {
    key: 0,
    class: "cal-person"
};
var _hoisted_30 = {
    class: "cal-avatar",
    style: { "background": "#0891b2" }
};
var _hoisted_31 = { class: "cal-person-name" };
var _hoisted_32 = { class: "cal-person-sub" };
var _hoisted_33 = {
    key: 1,
    class: "cal-card-empty"
};
var _hoisted_34 = { class: "cal-status-value" };
var _hoisted_35 = { class: "cal-card" };
var _hoisted_36 = { class: "cal-check" };
var _hoisted_37 = { key: 0 };
var _hoisted_38 = { key: 1 };
var _hoisted_39 = { key: 2 };
var _hoisted_40 = { class: "cal-main" };
var _hoisted_41 = { class: "cal-header" };
var _hoisted_42 = { class: "cal-header-controls" };
var _hoisted_43 = { class: "view-toggle" };
var _hoisted_44 = {
    key: 0,
    class: "cal-empty-state"
};
var _hoisted_45 = {
    key: 1,
    class: "month-grid"
};
var _hoisted_46 = { class: "month-grid-head" };
var _hoisted_47 = { class: "month-grid-body" };
var _hoisted_48 = ["onClick"];
var _hoisted_49 = { class: "month-cell-num" };
var _hoisted_50 = { class: "month-chips" };
var _hoisted_51 = {
    key: 0,
    class: "month-chip-more"
};
var _hoisted_52 = {
    key: 2,
    class: "week-grid"
};
var _hoisted_53 = { class: "wd-name" };
var _hoisted_54 = { class: "wd-num" };
var _hoisted_55 = { class: "week-gutter" };
var _hoisted_56 = ["onClick"];
var _hoisted_57 = ["title", "onClick"];
var _hoisted_58 = { class: "cal-event-time" };
var _hoisted_59 = { class: "cal-event-title" };
var _hoisted_60 = {
    key: 3,
    class: "cal-legend"
};
var _hoisted_61 = { class: "edit-modal booking-modal" };
var _hoisted_62 = { class: "edit-header" };
var _hoisted_63 = { class: "modal-body" };
var _hoisted_64 = { class: "form-row" };
var _hoisted_65 = {
    key: 0,
    class: "cal-readonly-field"
};
var _hoisted_66 = ["value"];
var _hoisted_67 = { class: "form-row two-col" };
var _hoisted_68 = { key: 0 };
var _hoisted_69 = ["label"];
var _hoisted_70 = ["value"];
var _hoisted_71 = {
    key: 0,
    class: "cal-readonly-field"
};
var _hoisted_72 = ["value"];
var _hoisted_73 = { class: "form-row" };
var _hoisted_74 = ["disabled"];
var _hoisted_75 = ["value"];
var _hoisted_76 = {
    key: 0,
    class: "compat-grid"
};
var _hoisted_77 = { class: "compat-col compat-facts" };
var _hoisted_78 = { class: "compat-fact" };
var _hoisted_79 = { class: "compat-fact" };
var _hoisted_80 = { class: "compat-col compat-details-col" };
var _hoisted_81 = { class: "compat-more-toggle" };
var _hoisted_82 = {
    key: 0,
    class: "compat-summary"
};
var _hoisted_83 = { class: "compat-line" };
var _hoisted_84 = {
    key: 0,
    class: "compat-line"
};
var _hoisted_85 = { class: "form-row" };
var _hoisted_86 = { class: "mini-month" };
var _hoisted_87 = { class: "mini-month-head" };
var _hoisted_88 = { class: "mini-month-grid" };
var _hoisted_89 = ["onClick"];
var _hoisted_90 = { class: "form-row two-col" };
var _hoisted_91 = ["value"];
var _hoisted_92 = ["value"];
var _hoisted_93 = {
    key: 1,
    class: "no-slots-hint"
};
var _hoisted_94 = { class: "form-row" };
var _hoisted_95 = {
    key: 2,
    class: "form-row recurrence-row"
};
var _hoisted_96 = { class: "recurrence-mode" };
var _hoisted_97 = {
    key: 0,
    class: "recurrence-days"
};
var _hoisted_98 = ["onClick"];
var _hoisted_99 = { class: "recurrence-end" };
var _hoisted_100 = { class: "recurrence-end-option" };
var _hoisted_101 = ["disabled"];
var _hoisted_102 = { class: "recurrence-end-option" };
var _hoisted_103 = ["disabled"];
var _hoisted_104 = {
    key: 1,
    class: "series-preview"
};
var _hoisted_105 = { class: "series-preview-summary" };
var _hoisted_106 = { key: 0 };
var _hoisted_107 = { key: 1 };
var _hoisted_108 = { class: "series-preview-list" };
var _hoisted_109 = ["title"];
var _hoisted_110 = {
    key: 0,
    class: "viability-reasons"
};
var _hoisted_111 = { class: "notify-row" };
var _hoisted_112 = { class: "notify-toggle" };
var _hoisted_113 = { class: "notify-recipients" };
var _hoisted_114 = { class: "notify-method" };
var _hoisted_115 = {
    key: 0,
    class: "group-select-wrap"
};
var _hoisted_116 = ["label"];
var _hoisted_117 = ["value"];
var _hoisted_118 = {
    key: 4,
    class: "form-error"
};
var _hoisted_119 = { class: "edit-footer" };
var _hoisted_120 = ["disabled"];
var _hoisted_121 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var _hoisted_122 = {
    key: 1,
    class: "glyphicon glyphicon-ok"
};
var _hoisted_123 = { class: "edit-modal" };
var _hoisted_124 = { class: "edit-header" };
var _hoisted_125 = { class: "modal-body" };
var _hoisted_126 = { class: "booking-summary" };
var _hoisted_127 = { class: "bs-value" };
var _hoisted_128 = { class: "bs-value" };
var _hoisted_129 = { class: "bs-value" };
var _hoisted_130 = { class: "bs-value" };
var _hoisted_131 = { key: 0 };
var _hoisted_132 = { class: "bs-value" };
var _hoisted_133 = { key: 1 };
var _hoisted_134 = {
    key: 0,
    class: "scope-chooser"
};
var _hoisted_135 = { class: "scope-chooser-title" };
var _hoisted_136 = { class: "scope-option" };
var _hoisted_137 = { class: "scope-option" };
var _hoisted_138 = { class: "scope-option" };
var _hoisted_139 = { class: "scope-chooser-actions" };
var _hoisted_140 = ["disabled"];
var _hoisted_141 = { class: "details-actions" };
var _hoisted_142 = ["disabled"];
var _hoisted_143 = ["disabled"];
var _hoisted_144 = { class: "notify-row" };
var _hoisted_145 = { class: "notify-toggle" };
var _hoisted_146 = { class: "notify-recipients" };
var _hoisted_147 = { class: "notify-method" };
var _hoisted_148 = {
    key: 0,
    class: "group-select-wrap"
};
var _hoisted_149 = ["label"];
var _hoisted_150 = ["value"];
var _hoisted_151 = {
    key: 0,
    class: "cal-toast"
};
var vue_3 = require("vue");
var patientCardsStore_1 = require("../../../stores/patientCardsStore");
var appointmentApiService_1 = require("../../../services/appointmentApiService");
var patientAvailabilityService_1 = require("../../../services/patientAvailabilityService");
var useSchedulingAccess_1 = require("@/composables/useSchedulingAccess");
var schedulingCustomizationApi_1 = require("@/api/schedulingCustomizationApi");
var ROW_HEIGHT = 48;
exports.default = (0, vue_1.defineComponent)({
    __name: 'SchedulingCalendar',
    props: {
        accountnumber: {},
        access: {},
        actorId: {}
    },
    setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose;
        var props = __props;
        var access = (0, vue_3.computed)(function () { return props.access; });
        var store = (0, patientCardsStore_1.usePatientCardsStore)();
        var patients = (0, vue_3.computed)(function () { return store.patients; });
        // Practice-wide cap on caregivers with overlapping visits for the same
        // patient — independent of caregiverPairCompat (see evaluateBookingSlot).
        // Admin-configurable via ManageScheduling.vue's Settings dropdown.
        var maxConcurrentCaregivers = (0, vue_3.ref)(2);
        // Whether the booking action should show — admin/caregiver always can; a
        // patient/family-in-chart session only when granted.
        var canAdd = (0, vue_3.computed)(function () { var _a; return ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) !== 'patient' || !!props.access.canAdd; });
        // Caregiver Type selector (unlocks every caregiver type in the dropdown
        // below) shows for a true admin, and equally for a clinician viewing the chart with full
        // scheduling access locked into a specific patient's chart — otherwise the
        // caregiver dropdown stays stuck on whatever category it defaulted to,
        // hiding Nurse/HHA/Allied entirely regardless of their access.
        var showCaregiverTypeSelector = (0, vue_3.computed)(function () { var _a, _b; return ((_a = props.access) === null || _a === void 0 ? void 0 : _a.kind) === 'admin' || (((_b = props.access) === null || _b === void 0 ? void 0 : _b.kind) === 'patient' && !!props.access.fullAccess); });
        (0, vue_3.onMounted)(function () { return __awaiter(_this, void 0, void 0, function () {
            var uiSettings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // patients is identity-scoped (whoever is currently logged in) and must be
                    // refetched fresh on every mount — see MasterCalendar.vue's onMounted for
                    // why a stale "already loaded" guard here is unsafe across a user switch.
                    return [4 /*yield*/, store.loadPatientsFromStaffPatientsGroup()];
                    case 1:
                        // patients is identity-scoped (whoever is currently logged in) and must be
                        // refetched fresh on every mount — see MasterCalendar.vue's onMounted for
                        // why a stale "already loaded" guard here is unsafe across a user switch.
                        _a.sent();
                        if (!(store.providers.length === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, store.loadProviders()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(store.nurses.length === 0)) return [3 /*break*/, 5];
                        return [4 /*yield*/, store.loadNurses()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [4 /*yield*/, store.loadAppointmentsForPatients()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, (0, appointmentApiService_1.getSchedulingUiSettings)(props.accountnumber)];
                    case 7:
                        uiSettings = _a.sent();
                        maxConcurrentCaregivers.value = uiSettings.maxConcurrentCaregivers;
                        return [4 /*yield*/, loadCustomContexts()];
                    case 8:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        // Admin-defined custom Context values (Administration -> Customization ->
        // In-Home Visit Context) — appended to the Context dropdown below, on top of
        // the static CAREGIVER_CONTEXTS list.
        var customContexts = (0, vue_3.ref)([]);
        function loadCustomContexts() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, schedulingCustomizationApi_1.getCustomSchedulingContexts)({ accountnumber: props.accountnumber })];
                        case 1:
                            res = _a.sent();
                            customContexts.value = (res === null || res === void 0 ? void 0 : res.status) === 'Successful' && Array.isArray(res.data) ? res.data : [];
                            return [2 /*return*/];
                    }
                });
            });
        }
        /* ── Caregiver type / credential ──────────────────────────────────
         * Replaces the old Provider/Nurse toggle + category-filter buttons (the
         * stakeholder found that two-tier control confusing) with a single
         * optgrouped dropdown: one <select>, grouped by broad staffing type
         * (Nurses / Allied Professionals / Providers), with the actual selectable
         * values being real credentials pulled from the roster data itself — e.g.
         * Nurses -> RN / LPN / HHA, Allied Professionals -> PT / OT / RT — rather
         * than a hardcoded list that might not match what a given org actually has.
         * ────────────────────────────────────────────────────────────────── */
        var activeCategory = (0, vue_3.ref)('');
        // Specific credential within activeCategory (e.g. 'RN', 'PT') — '' means
        // "any credential in this category." Nurses already carry a clean short
        // credential (see getSchedulingNurseStaff's credMap); providers/allied only
        // have free-text specialty strings, so abbreviateCredential() derives a
        // short label the same way (e.g. "Physical Therapist" -> "PT").
        var activeSubCredential = (0, vue_3.ref)('');
        function abbreviateCredential(text) {
            var t = (text !== null && text !== void 0 ? text : '').trim();
            if (!t)
                return '';
            if (!t.includes(' '))
                return t.toUpperCase();
            return t.split(/\s+/).map(function (w) { return w[0]; }).join('').toUpperCase();
        }
        var caregiverTypeGroups = (0, vue_3.computed)(function () {
            var nurseCats = new Map();
            for (var _i = 0, _a = store.nurses; _i < _a.length; _i++) {
                var n = _a[_i];
                nurseCats.set(n.credential || 'Other', n.category === 'hha' ? 'hha' : 'nurse');
            }
            var nurseOptions = Array.from(nurseCats.entries())
                .sort(function (_a, _b) {
                var a = _a[0];
                var b = _b[0];
                return a.localeCompare(b);
            })
                .map(function (_a) {
                var cred = _a[0], cat = _a[1];
                return ({ value: "".concat(cat, ":").concat(cred), label: cred });
            });
            var alliedAbbrs = new Set();
            for (var _b = 0, _c = store.providers.filter(function (p) { return p.category === 'allied'; }); _b < _c.length; _b++) {
                var p = _c[_b];
                alliedAbbrs.add(abbreviateCredential(p.credential) || 'Other');
            }
            var alliedOptions = Array.from(alliedAbbrs)
                .sort(function (a, b) { return a.localeCompare(b); })
                .map(function (abbr) { return ({ value: "allied:".concat(abbr), label: abbr }); });
            var providerAbbrs = new Set();
            for (var _d = 0, _e = store.providers.filter(function (p) { return !p.category || p.category === 'provider'; }); _d < _e.length; _d++) {
                var p = _e[_d];
                providerAbbrs.add(abbreviateCredential(p.credential));
            }
            var providerOptions = Array.from(providerAbbrs)
                .sort(function (a, b) { return a.localeCompare(b); })
                .map(function (abbr) { return ({ value: "provider:".concat(abbr), label: abbr || 'All Providers' }); });
            return [
                { label: 'Nurses', options: nurseOptions },
                { label: 'Allied Professionals', options: alliedOptions },
                { label: 'Providers', options: providerOptions }
            ].filter(function (g) { return g.options.length > 0; });
        });
        // v-model target for the single dropdown — a "category:subcredential"
        // composite key, parsed back out into the two underlying refs on select.
        var caregiverTypeSelection = (0, vue_3.computed)({
            get: function () { return (activeCategory.value ? "".concat(activeCategory.value, ":").concat(activeSubCredential.value) : ''); },
            set: function (val) {
                var sep = val.indexOf(':');
                activeCategory.value = (sep === -1 ? val : val.slice(0, sep));
                activeSubCredential.value = sep === -1 ? '' : val.slice(sep + 1);
                selectedCaregiverId.value = '';
            }
        });
        // filterStaffForAccess narrows the final result to just the caller for a
        // locked caregiver session -- see its own header for why this is
        // centralized rather than checked ad hoc here. Deliberately NOT applied to
        // caregiverTypeGroups above -- that's aggregated credential labels ("RN",
        // "MD"), not named individuals, so there's no identity to leak there.
        var caregiverOptions = (0, vue_3.computed)(function () {
            var list;
            if (activeCategory.value === 'provider')
                list = store.providers.filter(function (p) { return !p.category || p.category === 'provider'; });
            else if (activeCategory.value === 'allied')
                list = store.providers.filter(function (p) { return p.category === 'allied'; });
            else if (activeCategory.value === 'nurse')
                list = store.nurses.filter(function (n) { return n.category === 'nurse'; });
            else if (activeCategory.value === 'hha')
                list = store.nurses.filter(function (n) { return n.category === 'hha'; });
            else
                return [];
            if (activeSubCredential.value) {
                list = (activeCategory.value === 'nurse' || activeCategory.value === 'hha')
                    ? list.filter(function (c) { return c.credential === activeSubCredential.value; })
                    : list.filter(function (c) { return abbreviateCredential(c.credential) === activeSubCredential.value; });
            }
            return (0, useSchedulingAccess_1.filterStaffForAccess)(list, props.access);
        });
        var selectedCaregiverId = (0, vue_3.ref)('');
        var selectedCaregiver = (0, vue_3.computed)(function () { return caregiverOptions.value.find(function (c) { return c.id === selectedCaregiverId.value; }); });
        // "<type> - <name> is unavailable" instead of a bare "Caregiver Unavailable" —
        // stakeholder feedback was that the generic label reads as ambiguous even
        // though the caregiver is already picked via the dropdown + match-up card.
        // `specialty` already holds the right source column either way: providers/
        // allied map it from `providerType` (patientCardsStore.loadProviders), nurses/
        // HHA map it from `caregivetype` (getSchedulingNurseStaff) — same field, correct
        // per category, no branching needed here.
        var unavailableCaregiverTitle = (0, vue_3.computed)(function () {
            var c = selectedCaregiver.value;
            if (!c)
                return 'Caregiver Unavailable';
            var type = c.specialty || c.credential || 'Caregiver';
            return "".concat(type, " - ").concat(c.name, " is unavailable");
        });
        var caregiverType = (0, vue_3.computed)(function () {
            return selectedCaregiver.value
                ? (0, appointmentApiService_1.caregiverTypeForCredential)(selectedCaregiver.value.credential || selectedCaregiver.value.specialty || '', (activeCategory.value || 'provider'))
                : null;
        });
        // Custom contexts are all mapped to 'Out-of-Home Medical' for compatibility
        // purposes (rubricContext()), so they only make sense to offer a caregiver
        // type that's already eligible for that context — same rubric, same list.
        var contextOptions = (0, vue_3.computed)(function () {
            if (!caregiverType.value)
                return [];
            var base = (0, appointmentApiService_1.visitContextsForCaregiverType)(caregiverType.value);
            if (!base.includes('Out-of-Home Medical'))
                return base;
            return __spreadArray(__spreadArray([], base, true), customContexts.value.map(function (c) { return c.label; }), true);
        });
        var selectedContext = (0, vue_3.ref)('');
        (0, vue_3.watch)(contextOptions, function (opts) {
            if (selectedContext.value && !opts.includes(selectedContext.value))
                selectedContext.value = '';
        });
        var selectedPatientId = (0, vue_3.ref)('');
        var selectedPatient = (0, vue_3.computed)(function () { return store.patients.find(function (p) { var _a; return ((_a = p.psersonalID) !== null && _a !== void 0 ? _a : p.id) === selectedPatientId.value || p.id === selectedPatientId.value; }); });
        var canBook = (0, vue_3.computed)(function () { return !!(selectedPatientId.value && selectedCaregiver.value && selectedContext.value); });
        // Lock the caregiver/patient selection once access resolves (async, from the
        // parent's useSchedulingAccess()) — a caregiver books only as themselves
        // (their assigned-patients dropdown is already scoped server-side, see
        // patientCardsStore.ts loadPatientsFromStaffPatientsGroup); a patient/
        // family-in-chart session books only for the one patient whose chart is open.
        (0, vue_3.watch)(function () { return props.access; }, function (a) {
            if (!a)
                return;
            if (a.kind === 'caregiver') {
                activeCategory.value = a.category;
                selectedCaregiverId.value = a.staffId;
                return;
            }
            if (a.kind === 'patient') {
                selectedPatientId.value = a.patientId;
            }
        }, { immediate: true });
        function patientLabel(id) {
            var p = store.patients.find(function (p) { var _a; return ((_a = p.psersonalID) !== null && _a !== void 0 ? _a : p.id) === id || p.id === id; });
            return p ? "".concat(p.firstName, " ").concat(p.lastName) : id;
        }
        function caregiverNameById(id) {
            var _a, _b;
            return ((_a = store.providers.find(function (p) { return p.id === id; })) === null || _a === void 0 ? void 0 : _a.name) || ((_b = store.nurses.find(function (n) { return n.id === id; })) === null || _b === void 0 ? void 0 : _b.name) || id;
        }
        function initials(name) {
            return name.split(' ').filter(Boolean).slice(0, 2).map(function (w) { return w[0]; }).join('').toUpperCase();
        }
        /* ── Patient blocks + caregiver schedule caches ──────────────────── */
        var patientBlocksRaw = (0, vue_3.ref)([]);
        var caregiverRules = (0, vue_3.ref)([]);
        var caregiverTimeOffRaw = (0, vue_3.ref)([]);
        // Both loaders clear their state *before* awaiting (not just on deselect) and
        // guard against out-of-order resolution — without this, switching caregiver/
        // patient briefly renders the grid off the PREVIOUS selection's stale data
        // (e.g. zero availability rules → one giant "Caregiver Unavailable" band)
        // until the new fetch resolves, and a slower earlier request could overwrite
        // a newer one's result if requests resolve out of order.
        var patientBlocksRequestId = 0;
        function loadPatientBlocks() {
            return __awaiter(this, void 0, void 0, function () {
                var requestId, blocks;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requestId = ++patientBlocksRequestId;
                            patientBlocksRaw.value = [];
                            if (!selectedPatientId.value)
                                return [2 /*return*/];
                            return [4 /*yield*/, (0, patientAvailabilityService_1.getPatientBlocks)(props.accountnumber, selectedPatientId.value, 'in_home')];
                        case 1:
                            blocks = _a.sent();
                            if (requestId !== patientBlocksRequestId)
                                return [2 /*return*/];
                            patientBlocksRaw.value = blocks;
                            return [2 /*return*/];
                    }
                });
            });
        }
        var caregiverScheduleRequestId = 0;
        function loadCaregiverSchedule() {
            return __awaiter(this, void 0, void 0, function () {
                var requestId, _a, rules, timeOff;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            requestId = ++caregiverScheduleRequestId;
                            caregiverRules.value = [];
                            caregiverTimeOffRaw.value = [];
                            if (!selectedCaregiverId.value)
                                return [2 /*return*/];
                            return [4 /*yield*/, Promise.all([
                                    (0, appointmentApiService_1.getAvailabilityRules)(props.accountnumber, selectedCaregiverId.value),
                                    (0, appointmentApiService_1.getTimeOff)(props.accountnumber, selectedCaregiverId.value)
                                ])];
                        case 1:
                            _a = _b.sent(), rules = _a[0], timeOff = _a[1];
                            if (requestId !== caregiverScheduleRequestId)
                                return [2 /*return*/];
                            caregiverRules.value = rules;
                            caregiverTimeOffRaw.value = timeOff;
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.watch)(selectedPatientId, loadPatientBlocks, { immediate: true });
        (0, vue_3.watch)(selectedCaregiverId, loadCaregiverSchedule, { immediate: true });
        /* ── Date / time helpers ──────────────────────────────────────────── */
        var WEEKDAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        // Full 24h (00:00–24:00) so overnight shifts (e.g. 7pm–7am) are fully visible
        // instead of clipped at the edges of a daytime-only window.
        var HOURS = Array.from({ length: 24 }, function (_, i) { return i; });
        var GRID_START_MIN = HOURS[0] * 60;
        var GRID_END_MIN = (HOURS[HOURS.length - 1] + 1) * 60;
        var todayStr = new Date().toISOString().split('T')[0];
        function toDateStr(d) { return d.toISOString().split('T')[0]; }
        function mondayOf(d) {
            var copy = new Date(d);
            var dow = copy.getDay();
            copy.setDate(copy.getDate() + (dow === 0 ? -6 : 1 - dow));
            copy.setHours(0, 0, 0, 0);
            return copy;
        }
        function addDays(d, n) { var c = new Date(d); c.setDate(c.getDate() + n); return c; }
        function shiftMonth(d, n) { return new Date(d.getFullYear(), d.getMonth() + n, 1); }
        function dayNameFor(d) { return WEEKDAY_NAMES[(d.getDay() + 6) % 7]; }
        function toMin(time) { var _a = time.split(':').map(Number), h = _a[0], m = _a[1]; return h * 60 + m; }
        function minToHHMM(min) { return "".concat(String(Math.floor(min / 60)).padStart(2, '0'), ":").concat(String(min % 60).padStart(2, '0')); }
        function formatHourLabel(h) { var period = h >= 12 ? 'PM' : 'AM'; var hr = h % 12 === 0 ? 12 : h % 12; return "".concat(hr, " ").concat(period); }
        function formatTime(time) {
            var _a = time.split(':').map(Number), h = _a[0], m = _a[1];
            var period = h >= 12 ? 'PM' : 'AM';
            var dh = h % 12 === 0 ? 12 : h % 12;
            return "".concat(dh, ":").concat(String(m).padStart(2, '0'), " ").concat(period);
        }
        function formatMinLabel(min) { return formatTime(minToHHMM(((min % 1440) + 1440) % 1440)); }
        function formatDateShort(dateStr) {
            var _a = dateStr.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            return new Date(y, m - 1, d).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
        }
        /* ── Caregiver schedule, in minutes-since-midnight ───────────────── */
        function windowsForDow(dow) {
            return (0, appointmentApiService_1.resolveDaySegments)(dow, caregiverRules.value).map(function (s) { return ({ start: s.start, end: s.end }); });
        }
        function timeOffForDate(dateStr) {
            return caregiverTimeOffRaw.value
                .filter(function (o) { return o.offDate === dateStr; })
                .map(function (o) { return ({
                start: o.startTime ? toMin(o.startTime) : GRID_START_MIN,
                end: o.endTime ? toMin(o.endTime) : GRID_END_MIN
            }); });
        }
        var todaysWindows = (0, vue_3.computed)(function () { return windowsForDow(new Date().getDay()).map(function (w) { return "".concat(formatMinLabel(w.start), "\u2013").concat(formatMinLabel(w.end)); }); });
        /* ── Left rail — Patient Info / Compatibility Check ──────────────── */
        var patientTodayBlocks = (0, vue_3.computed)(function () { return (0, patientAvailabilityService_1.resolveBlocksForDate)(patientBlocksRaw.value, todayStr); });
        var patientStatus = (0, vue_3.computed)(function () {
            var now = new Date().getHours() * 60 + new Date().getMinutes();
            var active = patientTodayBlocks.value.find(function (b) { return toMin(b.start_time) <= now && toMin(b.end_time) > now; });
            if (active) {
                return {
                    text: "".concat(active.exclusivity === 'hard' ? active.context_label : 'Occupied', " (").concat(formatTime(active.start_time), "\u2013").concat(formatTime(active.end_time), ")"),
                    tone: active.exclusivity === 'hard' ? 'bad' : 'warn'
                };
            }
            return { text: 'Available', tone: 'ok' };
        });
        var patientUnavailableToday = (0, vue_3.computed)(function () {
            return patientTodayBlocks.value.map(function (b) { return ({
                hard: b.exclusivity === 'hard',
                range: "".concat(formatTime(b.start_time), "\u2013").concat(formatTime(b.end_time)),
                label: b.context_label
            }); });
        });
        var visitLine = (0, vue_3.computed)(function () {
            var _a, _b;
            if (!caregiverType.value || !selectedContext.value)
                return { verdict: '—', tone: 'muted' };
            var level = (_b = (_a = appointmentApiService_1.caregiverContextCompat[caregiverType.value]) === null || _a === void 0 ? void 0 : _a[(0, appointmentApiService_1.rubricContext)(selectedContext.value)]) !== null && _b !== void 0 ? _b : 'no';
            return {
                verdict: level === 'no' ? 'not allowed' : level === 'conditional' ? 'conditional' : 'allowed',
                tone: level === 'no' ? 'bad' : level === 'conditional' ? 'warn' : 'ok'
            };
        });
        // Short Yes/Conditional/No badge for the modal's at-a-glance compat facts —
        // visitLine.verdict is the same 3-state result, just spelled out longer for
        // the full sentence used in compat-summary/the left rail.
        var visitVerdictBadge = (0, vue_3.computed)(function () {
            if (visitLine.value.tone === 'ok')
                return 'Yes';
            if (visitLine.value.tone === 'warn')
                return 'Conditional';
            if (visitLine.value.tone === 'bad')
                return 'No';
            return '—';
        });
        // Collapsed by default each time the New Visit modal opens — see
        // openNewVisitModal/openRescheduleModal.
        var showCompatDetails = (0, vue_3.ref)(false);
        var parallelAllowed = (0, vue_3.computed)(function () {
            if (!caregiverType.value)
                return [];
            var row = appointmentApiService_1.caregiverPairCompat[caregiverType.value];
            return Object.entries(row)
                .filter(function (_a) {
                var type = _a[0], v = _a[1];
                return v !== 'no' && type !== caregiverType.value;
            })
                .map(function (_a) {
                var type = _a[0];
                return appointmentApiService_1.CAREGIVER_TYPE_LABELS[type];
            });
        });
        function viabilityIcon(decision) {
            if (decision === 'allowed')
                return 'bi-check-circle-fill viability-ok';
            if (decision === 'conditional')
                return 'bi-exclamation-triangle-fill viability-warn';
            return 'bi-x-circle-fill viability-bad';
        }
        function viabilityLabel(decision) {
            if (decision === 'allowed')
                return 'Allowed';
            if (decision === 'conditional')
                return 'Conditional — review before booking';
            return 'Blocked';
        }
        /* ── View / navigation ────────────────────────────────────────────── */
        var view = (0, vue_3.ref)('day');
        var currentDate = (0, vue_3.ref)(new Date());
        function goPrev() {
            if (view.value === 'month')
                currentDate.value = shiftMonth(currentDate.value, -1);
            else if (view.value === 'week')
                currentDate.value = addDays(currentDate.value, -7);
            else
                currentDate.value = addDays(currentDate.value, -1);
        }
        function goNext() {
            if (view.value === 'month')
                currentDate.value = shiftMonth(currentDate.value, 1);
            else if (view.value === 'week')
                currentDate.value = addDays(currentDate.value, 7);
            else
                currentDate.value = addDays(currentDate.value, 1);
        }
        function goToday() { currentDate.value = new Date(); }
        function jumpToDay(dateStr) {
            var _a = dateStr.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            currentDate.value = new Date(y, m - 1, d);
            view.value = 'day';
        }
        var weekDays = (0, vue_3.computed)(function () {
            var monday = mondayOf(currentDate.value);
            return Array.from({ length: 7 }, function (_, i) {
                var d = addDays(monday, i);
                return { date: d, dateStr: toDateStr(d), dayName: WEEKDAY_NAMES[i], dayNum: d.getDate() };
            });
        });
        var gridDays = (0, vue_3.computed)(function () {
            if (view.value === 'day') {
                var d = currentDate.value;
                return [{ date: d, dateStr: toDateStr(d), dayName: dayNameFor(d), dayNum: d.getDate() }];
            }
            return weekDays.value;
        });
        var gridColumnsStyle = (0, vue_3.computed)(function () { return ({ gridTemplateColumns: "64px repeat(".concat(gridDays.value.length, ", 1fr)") }); });
        var weekRangeLabel = (0, vue_3.computed)(function () {
            var days = weekDays.value;
            var opts = { month: 'short', day: 'numeric' };
            return "Schedule for Week of ".concat(days[0].date.toLocaleDateString(undefined, opts), " \u2013 ").concat(days[6].date.toLocaleDateString(undefined, opts), ", ").concat(days[6].date.getFullYear());
        });
        var dayLabel = (0, vue_3.computed)(function () { return currentDate.value.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' }); });
        var monthLabel = (0, vue_3.computed)(function () { return currentDate.value.toLocaleDateString(undefined, { month: 'long', year: 'numeric' }); });
        var headerLabel = (0, vue_3.computed)(function () { return view.value === 'month' ? monthLabel.value : view.value === 'day' ? dayLabel.value : weekRangeLabel.value; });
        var monthCells = (0, vue_3.computed)(function () { return buildMonthCells(currentDate.value); });
        function buildMonthCells(anchor) {
            var firstOfMonth = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
            var gridStart = mondayOf(firstOfMonth);
            return Array.from({ length: 42 }, function (_, i) {
                var d = addDays(gridStart, i);
                var dateStr = toDateStr(d);
                var dayApts = appointments.value.filter(function (a) { return a.date === dateStr && a.status !== 'cancelled'; }).sort(function (a, b) { return a.time.localeCompare(b.time); });
                return {
                    date: d,
                    dateStr: dateStr,
                    dayNum: d.getDate(),
                    inMonth: d.getMonth() === anchor.getMonth(),
                    visible: dayApts.slice(0, 3),
                    overflow: Math.max(0, dayApts.length - 3)
                };
            });
        }
        /* ── Appointments ─────────────────────────────────────────────────
         * Sourced from the store's own appointments list (loaded via the proven
         * GetAppointmentsForPatients endpoint, populated for every loaded patient)
         * rather than a separate per-provider fetch — there's no backend endpoint
         * for a provider+date-range query, so filtering client-side reuses what
         * already works and stays reactive to the store's own create/update/cancel
         * side effects (no manual refetch needed after booking).
         * ────────────────────────────────────────────────────────────────── */
        var appointments = (0, vue_3.computed)(function () { return store.appointments.filter(function (a) { return a.providerId === selectedCaregiverId.value; }); });
        // store.appointments' patientId is normalized to the patient's internal `.id`
        // (see loadAppointmentsForPatients), while selectedPatientId prefers psersonalID —
        // resolve to the internal id so patient-scoped lookups actually match.
        var selectedPatientRecordId = (0, vue_3.computed)(function () {
            var _a;
            var p = store.patients.find(function (p) { var _a; return ((_a = p.psersonalID) !== null && _a !== void 0 ? _a : p.id) === selectedPatientId.value || p.id === selectedPatientId.value; });
            return (_a = p === null || p === void 0 ? void 0 : p.id) !== null && _a !== void 0 ? _a : selectedPatientId.value;
        });
        var patientAppointments = (0, vue_3.computed)(function () { return store.appointments.filter(function (a) { return a.patientId === selectedPatientRecordId.value; }); });
        function caregiverTypeForStaffId(staffId) {
            var _a;
            var staff = store.providers.find(function (p) { return p.id === staffId; }) || store.nurses.find(function (n) { return n.id === staffId; });
            if (!staff)
                return null;
            return (0, appointmentApiService_1.caregiverTypeForCredential)(staff.credential || staff.specialty || '', (_a = staff.category) !== null && _a !== void 0 ? _a : 'provider');
        }
        /* ── Unified calendar events (patient blocks + caregiver gaps + visits) ── */
        function buildDayEvents(dateStr, dow) {
            var _a, _b;
            var events = [];
            // Nothing to plot until a patient AND caregiver are both picked — without
            // this, zero configured availability rules for "no caregiver selected"
            // reads identically to "this caregiver has zero hours," so the whole grid
            // fills with a "Caregiver Unavailable" band before anyone's even chosen
            // whose calendar they're looking at (confusing in an org with 200+
            // providers). See the empty-state message in the template for the other
            // half of this fix.
            if (!selectedPatientId.value || !selectedCaregiverId.value)
                return events;
            for (var _i = 0, _c = (0, patientAvailabilityService_1.resolveBlocksForDate)(patientBlocksRaw.value, dateStr); _i < _c.length; _i++) {
                var b = _c[_i];
                events.push({
                    kind: b.exclusivity === 'hard' ? 'hard' : 'soft',
                    startMin: toMin(b.start_time), endMin: toMin(b.end_time),
                    startLabel: formatTime(b.start_time), endLabel: formatTime(b.end_time),
                    title: b.exclusivity === 'hard' ? 'Patient Unavailable' : "Occupied \u00B7 ".concat(b.context_label)
                });
            }
            var windows = windowsForDow(dow).slice().sort(function (a, b) { return a.start - b.start; });
            var cursor = GRID_START_MIN;
            var gaps = [];
            if (windows.length === 0) {
                gaps.push({ start: GRID_START_MIN, end: GRID_END_MIN });
            }
            else {
                for (var _d = 0, windows_1 = windows; _d < windows_1.length; _d++) {
                    var w = windows_1[_d];
                    if (w.start > cursor)
                        gaps.push({ start: cursor, end: w.start });
                    cursor = Math.max(cursor, w.end);
                }
                if (cursor < GRID_END_MIN)
                    gaps.push({ start: cursor, end: GRID_END_MIN });
            }
            for (var _e = 0, _f = timeOffForDate(dateStr); _e < _f.length; _e++) {
                var off = _f[_e];
                gaps.push(off);
            }
            for (var _g = 0, gaps_1 = gaps; _g < gaps_1.length; _g++) {
                var g = gaps_1[_g];
                if (g.end <= g.start)
                    continue;
                events.push({
                    kind: 'cunavail', startMin: g.start, endMin: g.end,
                    startLabel: formatMinLabel(g.start), endLabel: formatMinLabel(g.end),
                    title: unavailableCaregiverTitle.value
                });
            }
            for (var _h = 0, _j = appointments.value.filter(function (a) { return a.date === dateStr && a.status !== 'cancelled'; }); _h < _j.length; _h++) {
                var a = _j[_h];
                var startMin = toMin(a.time);
                var endMin = startMin + ((_a = a.durationMinutes) !== null && _a !== void 0 ? _a : 60);
                events.push({
                    kind: 'scheduled',
                    startMin: startMin,
                    endMin: endMin,
                    startLabel: formatTime(a.time), endLabel: formatMinLabel(endMin),
                    title: "".concat(patientLabel(a.patientId), " \u00B7 ").concat(a.meetingType),
                    appointment: a
                });
            }
            // This patient's visits with OTHER caregivers on this date — the calendar is
            // scoped to one caregiver's schedule, but a parallel visit elsewhere needs to
            // be visible here too so a genuine overlap (e.g. a provider at 9:20 and an
            // allied professional at 9:30 with the same patient) is actually apparent.
            for (var _k = 0, _l = patientAppointments.value.filter(function (a) { return a.date === dateStr && a.status !== 'cancelled' && a.providerId !== selectedCaregiverId.value; }); _k < _l.length; _k++) {
                var a = _l[_k];
                var startMin = toMin(a.time);
                var endMin = startMin + ((_b = a.durationMinutes) !== null && _b !== void 0 ? _b : 60);
                events.push({
                    kind: 'other-caregiver',
                    startMin: startMin,
                    endMin: endMin,
                    startLabel: formatTime(a.time), endLabel: formatMinLabel(endMin),
                    title: "".concat(caregiverNameById(a.providerId), " \u00B7 ").concat(a.meetingType),
                    appointment: a
                });
            }
            return events;
        }
        // Google-Calendar-style side-by-side layout for events that overlap in time —
        // e.g. two providers with parallel visits — so concurrent visits stay visible
        // next to each other instead of stacking full-width on top of one another.
        // Standard column-assignment algorithm: sweep events by start time, place each
        // in the first column whose previous occupant has already ended, and give
        // every event in a mutually-overlapping cluster the same column count (so
        // they each get an even fractional width).
        function layoutOverlaps(events) {
            var sorted = __spreadArray([], events, true).sort(function (a, b) { return a.startMin - b.startMin || a.endMin - b.endMin; });
            var result = [];
            var cluster = [];
            var columnEnds = [];
            var clusterEnd = -Infinity;
            function finalizeCluster() {
                if (cluster.length === 0)
                    return;
                var cols = Math.max.apply(Math, cluster.map(function (e) { return e.col; })) + 1;
                for (var _i = 0, cluster_1 = cluster; _i < cluster_1.length; _i++) {
                    var e = cluster_1[_i];
                    e.cols = cols;
                }
                cluster = [];
                columnEnds = [];
            }
            var _loop_1 = function (ev) {
                if (ev.startMin >= clusterEnd)
                    finalizeCluster();
                var col = columnEnds.findIndex(function (end) { return end <= ev.startMin; });
                if (col === -1) {
                    col = columnEnds.length;
                    columnEnds.push(ev.endMin);
                }
                else {
                    columnEnds[col] = ev.endMin;
                }
                var item = __assign(__assign({}, ev), { col: col, cols: 1 });
                cluster.push(item);
                result.push(item);
                clusterEnd = Math.max(clusterEnd, ev.endMin);
            };
            for (var _i = 0, sorted_1 = sorted; _i < sorted_1.length; _i++) {
                var ev = sorted_1[_i];
                _loop_1(ev);
            }
            finalizeCluster();
            return result;
        }
        function eventsForDay(dateStr, dow) {
            // Every kind (background availability bands, this caregiver's visits, and
            // other caregivers' visits with the same patient) shares one layout pass —
            // a patient-unavailable band overlapping a booked visit needs to stay just
            // as visible as two overlapping visits do, not hidden underneath one.
            var laidOut = layoutOverlaps(buildDayEvents(dateStr, dow));
            return laidOut.map(function (ev) {
                var widthPct = 100 / ev.cols;
                var leftPct = ev.col * widthPct;
                return __assign(__assign({}, ev), { style: {
                        top: "".concat(((ev.startMin - GRID_START_MIN) / 60) * ROW_HEIGHT, "px"),
                        height: "".concat(Math.max(((ev.endMin - ev.startMin) / 60) * ROW_HEIGHT - 2, 16), "px"),
                        left: "calc(".concat(leftPct, "% + 2px)"),
                        right: 'auto',
                        width: "calc(".concat(widthPct, "% - 4px)")
                    } });
            });
        }
        function onColumnClick(day, e, forcedMin) {
            var startMin = forcedMin;
            if (startMin == null) {
                var col = e.currentTarget;
                var rect = col.getBoundingClientRect();
                var y = e.clientY - rect.top;
                startMin = GRID_START_MIN + (y / ROW_HEIGHT) * 60;
            }
            openNewVisitModal(day.dateStr, Math.round(startMin / 15) * 15);
        }
        /* ── Booking modal ────────────────────────────────────────────────── */
        var bookingModalOpen = (0, vue_3.ref)(false);
        var rescheduleTarget = (0, vue_3.ref)(null);
        var bookingDate = (0, vue_3.ref)('');
        var bookingTime = (0, vue_3.ref)('');
        var bookingDuration = (0, vue_3.ref)(60);
        var bookingReason = (0, vue_3.ref)('');
        var bookingSlots = (0, vue_3.ref)([]);
        // Nurses/HHAs are shift-based — a visit can run the entire shift, so Duration
        // offers hourly increments up to the full shift length instead of the short
        // fixed increments used for Providers/Allied.
        var isShiftBased = (0, vue_3.computed)(function () { return activeCategory.value === 'nurse' || activeCategory.value === 'hha'; });
        function formatDurationLabel(min) {
            if (min < 60)
                return "".concat(min, " min");
            var hours = min / 60;
            var hoursStr = hours % 1 === 0 ? String(hours) : hours.toFixed(1);
            return "".concat(hoursStr, " hour").concat(hours === 1 ? '' : 's');
        }
        var selectedSlotMaxDuration = (0, vue_3.computed)(function () {
            var _a;
            var slot = bookingSlots.value.find(function (s) { return s.value === bookingTime.value; });
            return (_a = slot === null || slot === void 0 ? void 0 : slot.durationMinutes) !== null && _a !== void 0 ? _a : 60;
        });
        var durationOptions = (0, vue_3.computed)(function () {
            if (!isShiftBased.value) {
                return [
                    { value: 30, label: '30 min' },
                    { value: 45, label: '45 min' },
                    { value: 60, label: '1 hour' },
                    { value: 90, label: '1.5 hours' },
                    { value: 120, label: '2 hours' }
                ];
            }
            var max = selectedSlotMaxDuration.value;
            var STEP = 60;
            var opts = [];
            for (var m = STEP; m < max; m += STEP) {
                opts.push({ value: m, label: formatDurationLabel(m) });
            }
            opts.push({ value: max, label: "".concat(formatDurationLabel(max), " (full shift)") });
            return opts;
        });
        (0, vue_3.watch)(durationOptions, function (opts) {
            if (opts.length === 0 || opts.some(function (o) { return o.value === bookingDuration.value; }))
                return;
            bookingDuration.value = isShiftBased.value ? opts[opts.length - 1].value : 60;
        });
        function onBookingTimeSelected() {
            if (isShiftBased.value && bookingTime.value) {
                bookingDuration.value = selectedSlotMaxDuration.value;
            }
        }
        var bookingError = (0, vue_3.ref)('');
        var savingBooking = (0, vue_3.ref)(false);
        var miniMonthAnchor = (0, vue_3.ref)(new Date());
        var miniMonthLabel = (0, vue_3.computed)(function () { return miniMonthAnchor.value.toLocaleDateString(undefined, { month: 'long', year: 'numeric' }); });
        var miniMonthCells = (0, vue_3.computed)(function () {
            var firstOfMonth = new Date(miniMonthAnchor.value.getFullYear(), miniMonthAnchor.value.getMonth(), 1);
            var gridStart = mondayOf(firstOfMonth);
            return Array.from({ length: 42 }, function (_, i) {
                var d = addDays(gridStart, i);
                return { dateStr: toDateStr(d), dayNum: d.getDate(), inMonth: d.getMonth() === miniMonthAnchor.value.getMonth() };
            });
        });
        /* ── Recurrence (New Visit modal) ─────────────────────────────────── */
        var RECURRENCE_DAY_OPTIONS = [
            { value: 1, label: 'Mon' }, { value: 2, label: 'Tue' }, { value: 3, label: 'Wed' },
            { value: 4, label: 'Thu' }, { value: 5, label: 'Fri' }, { value: 6, label: 'Sat' }, { value: 0, label: 'Sun' }
        ];
        var recurrenceMode = (0, vue_3.ref)('none');
        var recurrenceDays = (0, vue_3.ref)([]);
        var recurrenceEndType = (0, vue_3.ref)('count');
        var recurrenceEndCount = (0, vue_3.ref)(8);
        var recurrenceEndDate = (0, vue_3.ref)('');
        // Set only while regenerating "this and following"/"entire series" after a
        // scoped reschedule — the new series belongs to the ORIGINAL visit's caregiver,
        // which may not be whoever is currently selected in the top toolbar (e.g.
        // rescheduling an other-caregiver's series).
        var seriesOverrideProviderId = (0, vue_3.ref)(null);
        function toggleRecurrenceDay(day) {
            var i = recurrenceDays.value.indexOf(day);
            if (i === -1)
                recurrenceDays.value = __spreadArray(__spreadArray([], recurrenceDays.value, true), [day], false);
            else
                recurrenceDays.value = recurrenceDays.value.filter(function (d) { return d !== day; });
        }
        var seriesRegenerateExcludeIds = (0, vue_3.ref)(new Set());
        function resetRecurrence() {
            recurrenceMode.value = 'none';
            recurrenceDays.value = [];
            recurrenceEndType.value = 'count';
            recurrenceEndCount.value = 8;
            recurrenceEndDate.value = '';
            seriesOverrideProviderId.value = null;
            seriesRegenerateExcludeIds.value = new Set();
        }
        var seriesPreview = (0, vue_3.computed)(function () {
            if (recurrenceMode.value === 'none' || !bookingDate.value || !bookingTime.value)
                return [];
            if (recurrenceMode.value === 'weekly' && recurrenceDays.value.length === 0)
                return [];
            var dates = (0, appointmentApiService_1.generateSeriesOccurrences)({
                startDate: bookingDate.value,
                recurrenceType: recurrenceMode.value,
                recurrenceDays: recurrenceMode.value === 'weekly' ? recurrenceDays.value : undefined,
                endType: recurrenceEndType.value,
                endCount: recurrenceEndType.value === 'count' ? recurrenceEndCount.value : undefined,
                endDate: recurrenceEndType.value === 'date' ? recurrenceEndDate.value : undefined
            });
            return dates.map(function (date) {
                var result = evaluateBookingSlot(date, bookingTime.value, bookingDuration.value, seriesRegenerateExcludeIds.value);
                return { date: date, decision: result.decision, reasons: result.reasons };
            });
        });
        var seriesPreviewSummary = (0, vue_3.computed)(function () { return ({
            total: seriesPreview.value.length,
            allowed: seriesPreview.value.filter(function (o) { return o.decision === 'allowed'; }).length,
            conditional: seriesPreview.value.filter(function (o) { return o.decision === 'conditional'; }).length,
            blocked: seriesPreview.value.filter(function (o) { return o.decision === 'blocked'; }).length
        }); });
        function selectBookingDate(dateStr) {
            bookingDate.value = dateStr;
            bookingTime.value = '';
        }
        // A shift is one continuous window, not one fixed-length visit — any number of
        // appointments (of varying length) can be booked inside it. Offer a start-time
        // candidate every 30 min across the whole window, each carrying how much room
        // is actually free from that point (to the next booked visit, time-off, or the
        // window's end), so the Duration dropdown can cap itself accordingly.
        function buildShiftBookingSlots(dateStr) {
            var _a;
            var dow = new Date(dateStr + 'T00:00:00').getDay();
            var daySegments = (0, appointmentApiService_1.resolveDaySegments)(dow, caregiverRules.value);
            if (daySegments.length === 0)
                return [];
            var blocked = [];
            for (var _i = 0, _b = caregiverTimeOffRaw.value; _i < _b.length; _i++) {
                var off = _b[_i];
                if (off.offDate !== dateStr)
                    continue;
                blocked.push({
                    start: off.startTime ? toMin(off.startTime) : 0,
                    end: off.endTime ? toMin(off.endTime) : 24 * 60
                });
            }
            for (var _c = 0, _d = appointments.value; _c < _d.length; _c++) {
                var a = _d[_c];
                if (a.date !== dateStr || a.status === 'cancelled')
                    continue;
                if (rescheduleTarget.value && a.id === rescheduleTarget.value.id)
                    continue;
                var start = toMin(a.time);
                blocked.push({ start: start, end: start + ((_a = a.durationMinutes) !== null && _a !== void 0 ? _a : 60) });
            }
            var STEP = 30;
            var results = [];
            for (var _e = 0, daySegments_1 = daySegments; _e < daySegments_1.length; _e++) {
                var _f = daySegments_1[_e], windowStart = _f.start, windowEnd = _f.end;
                var _loop_2 = function (t) {
                    if (blocked.some(function (b) { return t >= b.start && t < b.end; }))
                        return "continue";
                    var nextBoundary = Math.min.apply(Math, __spreadArray([windowEnd], blocked.filter(function (b) { return b.start > t; }).map(function (b) { return b.start; }), false));
                    var room = nextBoundary - t;
                    if (room < STEP)
                        return "continue";
                    var value = minToHHMM(t);
                    results.push({ value: value, label: formatTime(value), durationMinutes: room });
                };
                for (var t = windowStart; t < windowEnd; t += STEP) {
                    _loop_2(t);
                }
            }
            return results;
        }
        // bookingDate is set (triggering the watch below) AND explicitly called at
        // every open-site in the same tick — two concurrent invocations for the same
        // change. Without a staleness guard, whichever resolves last wins even if
        // it's the redundant one; if that one hits a transient failure it silently
        // overwrites a perfectly good result with an empty list (no visible error —
        // the time dropdown just looks empty). Mirrors the requestId guard already
        // used in loadCaregiverSchedule() for the same class of race.
        var bookingSlotsRequestId = 0;
        var loadingSlots = (0, vue_3.ref)(false);
        function loadBookingSlots(date) {
            return __awaiter(this, void 0, void 0, function () {
                var requestId, slots, res, slot;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requestId = ++bookingSlotsRequestId;
                            bookingSlots.value = [];
                            if (!date || !selectedCaregiverId.value)
                                return [2 /*return*/];
                            loadingSlots.value = true;
                            if (!isShiftBased.value) return [3 /*break*/, 1];
                            slots = buildShiftBookingSlots(date);
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, (0, appointmentApiService_1.getAvailability)(props.accountnumber, selectedCaregiverId.value, date)];
                        case 2:
                            res = _a.sent();
                            slots = res.slots
                                .filter(function (s) { return s.available && !s.booked && !s.capped; })
                                .map(function (s) { var _a; return ({ value: s.value, label: s.label, durationMinutes: (_a = s.durationMinutes) !== null && _a !== void 0 ? _a : 60 }); });
                            _a.label = 3;
                        case 3:
                            if (requestId !== bookingSlotsRequestId)
                                return [2 /*return*/];
                            bookingSlots.value = slots;
                            loadingSlots.value = false;
                            // New (not reschedule) shift-based booking with a start time already known
                            // (e.g. click-to-book) — default Duration to the full remaining room right away.
                            if (isShiftBased.value && !rescheduleTarget.value && bookingTime.value) {
                                slot = bookingSlots.value.find(function (s) { return s.value === bookingTime.value; });
                                if (slot)
                                    bookingDuration.value = slot.durationMinutes;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.watch)(bookingDate, function (date) { loadBookingSlots(date); });
        // The Start Time dropdown only ever lists genuinely open slots — a taken
        // time simply can't be selected, by design. Without an explanation, an empty
        // dropdown reads as broken rather than "this caregiver has nothing open
        // here." Surfaced only once a caregiver + date are picked and the
        // (non-stale) fetch has finished, so it never flashes during loading.
        var showNoSlotsHint = (0, vue_3.computed)(function () {
            return !loadingSlots.value && !!selectedCaregiverId.value && !!bookingDate.value && bookingSlots.value.length === 0;
        });
        var formattedBookingDate = (0, vue_3.computed)(function () {
            return bookingDate.value ? new Date(bookingDate.value + 'T00:00:00').toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) : '';
        });
        function resetNotify() {
            notifyOn.value = false;
            notifyPatient.value = true;
            notifyCaregiver.value = false;
            notifyMethod.value = 'email';
            notifyGroups.value = false;
            selectedGroupMembers.value = [];
        }
        function openNewVisitModal(dateStr, startMin) {
            rescheduleTarget.value = null;
            bookingDate.value = dateStr || todayStr;
            bookingTime.value = startMin != null ? minToHHMM(startMin) : '';
            bookingDuration.value = 60;
            bookingReason.value = '';
            bookingError.value = '';
            miniMonthAnchor.value = new Date(bookingDate.value + 'T00:00:00');
            resetNotify();
            resetRecurrence();
            showCompatDetails.value = false;
            loadBookingSlots(bookingDate.value);
            bookingModalOpen.value = true;
        }
        function openRescheduleModal() {
            var _a;
            if (!detailsVisit.value)
                return;
            rescheduleTarget.value = detailsVisit.value;
            bookingDate.value = detailsVisit.value.date;
            bookingTime.value = detailsVisit.value.time;
            bookingDuration.value = (_a = detailsVisit.value.durationMinutes) !== null && _a !== void 0 ? _a : 60;
            bookingReason.value = detailsVisit.value.reason || '';
            bookingError.value = '';
            miniMonthAnchor.value = new Date(detailsVisit.value.date + 'T00:00:00');
            resetNotify();
            resetRecurrence();
            showCompatDetails.value = false;
            loadBookingSlots(bookingDate.value);
            detailsModalOpen.value = false;
            bookingModalOpen.value = true;
        }
        // Reopens the New Visit modal pre-filled to regenerate a series after a
        // "this and following" / "entire series" reschedule — the old occurrences in
        // `scope` have already been cancelled by the caller. The recurrence pattern is
        // inferred from those occurrences' weekdays (best-effort default, always
        // reviewable/editable before the user confirms) rather than fetched from the
        // original series rule, so no new read endpoint is needed.
        function openRescheduleSeriesModal(target, scope) {
            var _a;
            rescheduleTarget.value = null;
            seriesOverrideProviderId.value = target.providerId;
            bookingDate.value = target.date;
            bookingTime.value = target.time;
            bookingDuration.value = (_a = target.durationMinutes) !== null && _a !== void 0 ? _a : 60;
            bookingReason.value = target.reason || '';
            bookingError.value = '';
            miniMonthAnchor.value = new Date(target.date + 'T00:00:00');
            resetNotify();
            var distinctDays = Array.from(new Set(scope.map(function (a) { return new Date(a.date + 'T00:00:00').getDay(); })));
            recurrenceMode.value = distinctDays.length >= 6 ? 'daily' : 'weekly';
            recurrenceDays.value = distinctDays;
            recurrenceEndType.value = 'count';
            recurrenceEndCount.value = Math.max(scope.length, 1);
            recurrenceEndDate.value = '';
            seriesRegenerateExcludeIds.value = new Set(scope.map(function (a) { return a.id; }));
            showCompatDetails.value = false;
            loadBookingSlots(bookingDate.value);
            detailsModalOpen.value = false;
            bookingModalOpen.value = true;
        }
        // Shared by the single-visit live check and the recurring-series preview —
        // gathers this component's local state into evaluateVisitViability()'s pure
        // inputs, so this and any other booking UI (e.g. a patient's own Master
        // Calendar booking modal) share one implementation instead of two copies
        // that can silently drift out of sync. `excludeIds` skips appointments being
        // replaced (a reschedule of itself, or old occurrences of a series being
        // regenerated).
        function evaluateBookingSlot(date, time, duration, excludeIds) {
            if (excludeIds === void 0) { excludeIds = new Set(); }
            var dow = new Date(date + 'T00:00:00').getDay();
            return (0, appointmentApiService_1.evaluateVisitViability)({
                date: date,
                time: time,
                duration: duration,
                excludeIds: excludeIds,
                caregiverType: caregiverType.value,
                caregiverContext: selectedContext.value,
                selectedCaregiverId: selectedCaregiverId.value,
                caregiverAppointments: appointments.value,
                patientAppointments: patientAppointments.value,
                resolveCaregiverType: caregiverTypeForStaffId,
                maxConcurrentCaregivers: maxConcurrentCaregivers.value,
                dayBlocks: (0, patientAvailabilityService_1.resolveBlocksForDate)(patientBlocksRaw.value, date),
                caregiverWindows: windowsForDow(dow),
                caregiverTimeOff: timeOffForDate(date)
            });
        }
        // A computed (not a ref + explicit watch list) so it re-evaluates on EVERY
        // input evaluateBookingSlot actually reads — caregiver, patient, context,
        // reschedule target, etc. — not just date/time/duration. An explicit watch
        // list previously missed those, so switching caregivers without also nudging
        // the date/time (e.g. reusing the same slot for a different caregiver) left
        // viability stale from the last caregiver checked, silently allowing bookings
        // that should have been blocked (including the concurrent-caregiver cap).
        var viability = (0, vue_3.computed)(function () {
            var excludeIds = rescheduleTarget.value ? new Set([rescheduleTarget.value.id]) : new Set();
            return evaluateBookingSlot(bookingDate.value, bookingTime.value, bookingDuration.value, excludeIds);
        });
        var canConfirmBooking = (0, vue_3.computed)(function () {
            if (!bookingDate.value || !bookingTime.value)
                return false;
            if (recurrenceMode.value !== 'none')
                return seriesPreview.value.some(function (o) { return o.decision !== 'blocked'; });
            return viability.value.decision !== 'blocked';
        });
        var confirmButtonLabel = (0, vue_3.computed)(function () {
            if (rescheduleTarget.value)
                return 'Save New Time';
            if (recurrenceMode.value !== 'none')
                return "Schedule ".concat(seriesPreviewSummary.value.total, " Visit").concat(seriesPreviewSummary.value.total === 1 ? '' : 's');
            return 'Confirm Visit';
        });
        /* ── Notify state (shared by New Visit + Visit Details) ─────────── */
        var notifyOn = (0, vue_3.ref)(false);
        var notifyPatient = (0, vue_3.ref)(true);
        var notifyCaregiver = (0, vue_3.ref)(false);
        var notifyMethod = (0, vue_3.ref)('email');
        // Care-team group notify — same GetPatientGroups data + resolveGroupMembers
        // logic as the patient card's quick-scheduling picker (AppointmentModule.vue),
        // so a visit can also notify a broader group, not just patient/caregiver.
        var notifyGroups = (0, vue_3.ref)(false);
        var groupOptions = (0, vue_3.ref)([]);
        var selectedGroupMembers = (0, vue_3.ref)([]);
        function loadPatientGroups() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!selectedPatient.value) {
                                groupOptions.value = [];
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, (0, appointmentApiService_1.findPatientGroups)(selectedPatient.value.id)];
                        case 1:
                            res = _b.sent();
                            groupOptions.value = ((_a = res === null || res === void 0 ? void 0 : res.groups) !== null && _a !== void 0 ? _a : []).filter(function (group) { var _a; return ((_a = group.members) === null || _a === void 0 ? void 0 : _a.length) > 0; });
                            return [2 /*return*/];
                    }
                });
            });
        }
        function toggleNotifyGroups() {
            notifyGroups.value = !notifyGroups.value;
            if (notifyGroups.value)
                loadPatientGroups();
        }
        function notifyPayload() {
            if (!notifyOn.value)
                return undefined;
            var groupMembers = notifyGroups.value ? (0, appointmentApiService_1.resolveGroupMembers)(groupOptions.value, selectedGroupMembers.value) : [];
            if (!notifyPatient.value && !notifyCaregiver.value && groupMembers.length === 0)
                return undefined;
            return { notifyPatient: notifyPatient.value, notifyCaregiver: notifyCaregiver.value, groupMembers: groupMembers, method: notifyMethod.value };
        }
        function notifySuffix() {
            var n = notifyPayload();
            if (!n)
                return '';
            var who = n.notifyPatient && n.notifyCaregiver ? 'patient & caregiver' : n.notifyPatient ? 'patient' : 'caregiver';
            return " \u00B7 ".concat(who, " notified via ").concat(n.method === 'sms' ? 'SMS' : 'Email');
        }
        var toast = (0, vue_3.ref)('');
        function showToast(msg) {
            toast.value = msg;
            setTimeout(function () { return (toast.value = ''); }, 2600);
        }
        function confirmSeriesBooking() {
            return __awaiter(this, void 0, void 0, function () {
                var bookable, providerId, providerName, seriesRes, createdCount, i, res, skipped;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            bookable = seriesPreview.value.filter(function (o) { return o.decision !== 'blocked'; });
                            if (bookable.length === 0) {
                                bookingError.value = 'No occurrences in this pattern are bookable — adjust the days, times, or end condition.';
                                return [2 /*return*/];
                            }
                            providerId = (_a = seriesOverrideProviderId.value) !== null && _a !== void 0 ? _a : selectedCaregiverId.value;
                            providerName = seriesOverrideProviderId.value ? caregiverNameById(providerId) : (((_b = selectedCaregiver.value) === null || _b === void 0 ? void 0 : _b.name) || '');
                            return [4 /*yield*/, (0, appointmentApiService_1.createAppointmentSeries)(props.accountnumber, {
                                    patientId: selectedPatientId.value,
                                    providerId: providerId,
                                    meetingType: selectedContext.value,
                                    durationMinutes: bookingDuration.value,
                                    reason: bookingReason.value || undefined,
                                    recurrenceType: recurrenceMode.value === 'daily' ? 'daily' : 'weekly',
                                    recurrenceDays: recurrenceMode.value === 'weekly' ? recurrenceDays.value : undefined,
                                    startDate: bookingDate.value,
                                    endType: recurrenceEndType.value,
                                    endCount: recurrenceEndType.value === 'count' ? recurrenceEndCount.value : undefined,
                                    endDate: recurrenceEndType.value === 'date' ? recurrenceEndDate.value : undefined
                                }, props.actorId)];
                        case 1:
                            seriesRes = _c.sent();
                            if (!seriesRes.success || !seriesRes.seriesId) {
                                bookingError.value = 'Could not create the recurring series. Please try again.';
                                return [2 /*return*/];
                            }
                            createdCount = 0;
                            i = 0;
                            _c.label = 2;
                        case 2:
                            if (!(i < bookable.length)) return [3 /*break*/, 5];
                            return [4 /*yield*/, store.scheduleAppointment({
                                    patientId: selectedPatientId.value,
                                    providerId: providerId,
                                    providerName: providerName,
                                    date: bookable[i].date,
                                    time: bookingTime.value,
                                    durationMinutes: bookingDuration.value,
                                    meetingType: selectedContext.value,
                                    reason: bookingReason.value || undefined,
                                    notifyEmail: false,
                                    notifySms: false,
                                    seriesId: seriesRes.seriesId
                                }, i === 0 ? notifyPayload() : undefined)];
                        case 3:
                            res = _c.sent();
                            if (res.success)
                                createdCount++;
                            _c.label = 4;
                        case 4:
                            i++;
                            return [3 /*break*/, 2];
                        case 5:
                            skipped = seriesPreview.value.length - bookable.length;
                            showToast("".concat(createdCount, " visit").concat(createdCount === 1 ? '' : 's', " scheduled").concat(skipped > 0 ? " \u00B7 ".concat(skipped, " skipped (blocked)") : '').concat(notifySuffix()));
                            return [2 /*return*/];
                    }
                });
            });
        }
        function confirmBooking() {
            return __awaiter(this, void 0, void 0, function () {
                var res, res;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!canConfirmBooking.value)
                                return [2 /*return*/];
                            savingBooking.value = true;
                            bookingError.value = '';
                            if (!rescheduleTarget.value) return [3 /*break*/, 2];
                            return [4 /*yield*/, store.updateAppointment(rescheduleTarget.value.id, {
                                    patientId: rescheduleTarget.value.patientId,
                                    providerId: rescheduleTarget.value.providerId,
                                    meetingType: rescheduleTarget.value.meetingType,
                                    date: bookingDate.value,
                                    time: bookingTime.value,
                                    durationMinutes: bookingDuration.value,
                                    reason: bookingReason.value || undefined
                                }, notifyPayload())];
                        case 1:
                            res = _b.sent();
                            savingBooking.value = false;
                            if (!res.success) {
                                bookingError.value = 'Could not reschedule this visit. Please try again.';
                                return [2 /*return*/];
                            }
                            showToast("Visit rescheduled".concat(notifySuffix()));
                            return [3 /*break*/, 6];
                        case 2:
                            if (!(recurrenceMode.value !== 'none')) return [3 /*break*/, 4];
                            return [4 /*yield*/, confirmSeriesBooking()];
                        case 3:
                            _b.sent();
                            savingBooking.value = false;
                            if (bookingError.value)
                                return [2 /*return*/];
                            return [3 /*break*/, 6];
                        case 4: return [4 /*yield*/, store.scheduleAppointment({
                                patientId: selectedPatientId.value,
                                providerId: selectedCaregiverId.value,
                                providerName: ((_a = selectedCaregiver.value) === null || _a === void 0 ? void 0 : _a.name) || '',
                                date: bookingDate.value,
                                time: bookingTime.value,
                                durationMinutes: bookingDuration.value,
                                meetingType: selectedContext.value,
                                reason: bookingReason.value || undefined,
                                notifyEmail: false,
                                notifySms: false
                            }, notifyPayload())];
                        case 5:
                            res = _b.sent();
                            savingBooking.value = false;
                            if (!res.success) {
                                bookingError.value = 'Could not schedule this visit. Please try again.';
                                return [2 /*return*/];
                            }
                            showToast("Visit scheduled".concat(notifySuffix()));
                            _b.label = 6;
                        case 6:
                            bookingModalOpen.value = false;
                            rescheduleTarget.value = null;
                            return [2 /*return*/];
                    }
                });
            });
        }
        /* ── Visit Details modal ──────────────────────────────────────────── */
        var detailsModalOpen = (0, vue_3.ref)(false);
        var detailsVisit = (0, vue_3.ref)(null);
        // When the clicked visit belongs to a series, Cancel/Reschedule first ask
        // which occurrences the action applies to — matching Google Calendar/Outlook.
        var scopeChoiceOpen = (0, vue_3.ref)(null);
        var scopeChoice = (0, vue_3.ref)('this');
        function openVisitDetails(apt) {
            detailsVisit.value = apt;
            resetNotify();
            scopeChoiceOpen.value = null;
            scopeChoice.value = 'this';
            detailsModalOpen.value = true;
        }
        function cancelVisit() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!detailsVisit.value)
                                return [2 /*return*/];
                            savingBooking.value = true;
                            return [4 /*yield*/, store.cancelAppointment(detailsVisit.value.id, notifyPayload())];
                        case 1:
                            res = _a.sent();
                            savingBooking.value = false;
                            if (!res.success)
                                return [2 /*return*/];
                            showToast("Visit cancelled".concat(notifySuffix()));
                            detailsModalOpen.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function startCancelVisit() {
            if (!detailsVisit.value)
                return;
            if (!detailsVisit.value.seriesId) {
                cancelVisit();
                return;
            }
            scopeChoice.value = 'this';
            scopeChoiceOpen.value = 'cancel';
        }
        function startReschedule() {
            if (!detailsVisit.value)
                return;
            if (!detailsVisit.value.seriesId) {
                openRescheduleModal();
                return;
            }
            scopeChoice.value = 'this';
            scopeChoiceOpen.value = 'reschedule';
        }
        function seriesSiblings(target, includePast) {
            return patientAppointments.value.filter(function (a) {
                return a.seriesId === target.seriesId && a.status !== 'cancelled' && (includePast || a.date >= target.date);
            });
        }
        function confirmScopedAction() {
            return __awaiter(this, void 0, void 0, function () {
                var target, action, scope, targets, cancelledCount, _i, targets_1, occ, res, targets, _a, targets_2, occ;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!detailsVisit.value || !scopeChoiceOpen.value)
                                return [2 /*return*/];
                            target = detailsVisit.value;
                            action = scopeChoiceOpen.value;
                            scope = scopeChoice.value;
                            if (!(action === 'cancel')) return [3 /*break*/, 7];
                            if (!(scope === 'this')) return [3 /*break*/, 2];
                            return [4 /*yield*/, cancelVisit()];
                        case 1:
                            _b.sent();
                            scopeChoiceOpen.value = null;
                            return [2 /*return*/];
                        case 2:
                            targets = seriesSiblings(target, scope === 'series');
                            savingBooking.value = true;
                            cancelledCount = 0;
                            _i = 0, targets_1 = targets;
                            _b.label = 3;
                        case 3:
                            if (!(_i < targets_1.length)) return [3 /*break*/, 6];
                            occ = targets_1[_i];
                            return [4 /*yield*/, store.cancelAppointment(occ.id, occ.id === target.id ? notifyPayload() : undefined)];
                        case 4:
                            res = _b.sent();
                            if (res.success)
                                cancelledCount++;
                            _b.label = 5;
                        case 5:
                            _i++;
                            return [3 /*break*/, 3];
                        case 6:
                            savingBooking.value = false;
                            showToast("".concat(cancelledCount, " visit").concat(cancelledCount === 1 ? '' : 's', " cancelled").concat(notifySuffix()));
                            detailsModalOpen.value = false;
                            scopeChoiceOpen.value = null;
                            return [3 /*break*/, 12];
                        case 7:
                            if (scope === 'this') {
                                openRescheduleModal();
                                scopeChoiceOpen.value = null;
                                return [2 /*return*/];
                            }
                            targets = seriesSiblings(target, scope === 'series');
                            savingBooking.value = true;
                            _a = 0, targets_2 = targets;
                            _b.label = 8;
                        case 8:
                            if (!(_a < targets_2.length)) return [3 /*break*/, 11];
                            occ = targets_2[_a];
                            return [4 /*yield*/, store.cancelAppointment(occ.id)]; // no per-occurrence notify during a bulk regenerate
                        case 9:
                            _b.sent(); // no per-occurrence notify during a bulk regenerate
                            _b.label = 10;
                        case 10:
                            _a++;
                            return [3 /*break*/, 8];
                        case 11:
                            savingBooking.value = false;
                            scopeChoiceOpen.value = null;
                            openRescheduleSeriesModal(target, targets);
                            _b.label = 12;
                        case 12: return [2 /*return*/];
                    }
                });
            });
        }
        /* ── External hand-off from the Master Calendar's "Edit in Scheduler" ───── */
        function focusVisit(ev) {
            if (!ev)
                return;
            activeCategory.value = ev.caregiverCategory;
            activeSubCredential.value = '';
            selectedCaregiverId.value = ev.caregiverId;
            if (ev.patientId) {
                var patientRecord = store.patients.find(function (p) { return p.id === ev.patientId; });
                selectedPatientId.value = (patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.psersonalID) || (patientRecord === null || patientRecord === void 0 ? void 0 : patientRecord.id) || ev.patientId;
            }
            var _a = ev.date.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            currentDate.value = new Date(y, m - 1, d);
            view.value = 'day';
            // MasterCalendar splits a visit that runs past midnight into two rendered
            // events (one per calendar day) with the second half's id suffixed
            // "-next" so list :key stays unique — strip it back off to find the one
            // real appointment in the store.
            var realId = ev.id.endsWith('-next') ? ev.id.slice(0, -'-next'.length) : ev.id;
            var apt = store.appointments.find(function (a) { return a.id === realId; });
            if (apt)
                openVisitDetails(apt);
        }
        __expose({ focusVisit: focusVisit });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            _cache[49] || (_cache[49] = (0, vue_2.createElementVNode)("label", null, "Patient", -1)),
                            (((_a = access.value) === null || _a === void 0 ? void 0 : _a.kind) === 'patient')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_5, [
                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(access.value.patientName), 1)
                                ]))
                                : (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("select", {
                                    key: 1,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((selectedPatientId).value = $event); }),
                                    class: "cal-select"
                                }, [
                                    _cache[48] || (_cache[48] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select a patient —", -1)),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(patients.value, function (p) {
                                        var _a, _b;
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: (_a = p.psersonalID) !== null && _a !== void 0 ? _a : p.id,
                                            value: (_b = p.psersonalID) !== null && _b !== void 0 ? _b : p.id
                                        }, (0, vue_2.toDisplayString)(p.firstName) + " " + (0, vue_2.toDisplayString)(p.lastName) + " — " + (0, vue_2.toDisplayString)(p.mrn), 9, _hoisted_6));
                                    }), 128))
                                ], 512)), [
                                    [vue_2.vModelSelect, selectedPatientId.value]
                                ])
                        ]),
                        _cache[50] || (_cache[50] = (0, vue_2.createElementVNode)("div", { class: "cal-role-heading" }, [
                            (0, vue_2.createElementVNode)("h2", null, "Schedule an Appointment"),
                            (0, vue_2.createElementVNode)("p", null, "Select a Patient & Caregiver to view Compatibility and Create New Appointment")
                        ], -1))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_7, [
                        (showCaregiverTypeSelector.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                _cache[52] || (_cache[52] = (0, vue_2.createElementVNode)("label", null, "Caregiver Type", -1)),
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((caregiverTypeSelection).value = $event); }),
                                    class: "cal-select"
                                }, [
                                    _cache[51] || (_cache[51] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select caregiver type —", -1)),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(caregiverTypeGroups.value, function (group) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("optgroup", {
                                            key: group.label,
                                            label: group.label
                                        }, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.options, function (opt) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                    key: opt.value,
                                                    value: opt.value
                                                }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_10));
                                            }), 128))
                                        ], 8, _hoisted_9));
                                    }), 128))
                                ], 512), [
                                    [vue_2.vModelSelect, caregiverTypeSelection.value]
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            _cache[54] || (_cache[54] = (0, vue_2.createElementVNode)("label", null, "Caregiver", -1)),
                            (((_b = access.value) === null || _b === void 0 ? void 0 : _b.kind) === 'caregiver')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_12, [
                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(((_c = selectedCaregiver.value) === null || _c === void 0 ? void 0 : _c.name) || 'You'), 1)
                                ]))
                                : (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("select", {
                                    key: 1,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((selectedCaregiverId).value = $event); }),
                                    class: "cal-select"
                                }, [
                                    _cache[53] || (_cache[53] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select a caregiver —", -1)),
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(caregiverOptions.value, function (c) {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                            key: c.id,
                                            value: c.id
                                        }, (0, vue_2.toDisplayString)(c.name) + " — " + (0, vue_2.toDisplayString)(c.specialty || c.credential), 9, _hoisted_13));
                                    }), 128))
                                ], 512)), [
                                    [vue_2.vModelSelect, selectedCaregiverId.value]
                                ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                            _cache[55] || (_cache[55] = (0, vue_2.createElementVNode)("label", null, "Visit Type", -1)),
                            (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)(((_d = selectedCaregiver.value) === null || _d === void 0 ? void 0 : _d.specialty) || ((_e = selectedCaregiver.value) === null || _e === void 0 ? void 0 : _e.credential) || '—'), 1)
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            _cache[57] || (_cache[57] = (0, vue_2.createElementVNode)("label", null, "Context", -1)),
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((selectedContext).value = $event); }),
                                class: "cal-select",
                                disabled: !selectedCaregiver.value
                            }, [
                                _cache[56] || (_cache[56] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select context —", -1)),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(contextOptions.value, function (ctx) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                        key: ctx,
                                        value: ctx
                                    }, (0, vue_2.toDisplayString)(ctx), 9, _hoisted_18));
                                }), 128))
                            ], 8, _hoisted_17), [
                                [vue_2.vModelSelect, selectedContext.value]
                            ])
                        ]),
                        (canAdd.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                key: 1,
                                class: "btn-new-visit",
                                disabled: !canBook.value,
                                onClick: _cache[4] || (_cache[4] = function ($event) { return (openNewVisitModal()); })
                            }, __spreadArray([], (_cache[58] || (_cache[58] = [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-plus" }, null, -1),
                                (0, vue_2.createTextVNode)(" New Visit ", -1)
                            ])), true), 8, _hoisted_19))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_20, [
                    (0, vue_2.createElementVNode)("aside", _hoisted_21, [
                        (0, vue_2.createElementVNode)("section", _hoisted_22, [
                            _cache[60] || (_cache[60] = (0, vue_2.createElementVNode)("h3", { class: "cal-card-title" }, "Patient Info", -1)),
                            (selectedPatient.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, [
                                    (0, vue_2.createElementVNode)("span", {
                                        class: "cal-avatar",
                                        style: (0, vue_2.normalizeStyle)({ background: selectedPatient.value.avatarColor || '#7c3aed' })
                                    }, (0, vue_2.toDisplayString)(initials(patientLabel(selectedPatientId.value))), 5),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_24, (0, vue_2.toDisplayString)(selectedPatient.value.firstName) + " " + (0, vue_2.toDisplayString)(selectedPatient.value.lastName), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_25, (0, vue_2.toDisplayString)(selectedPatient.value.mrn), 1)
                                    ])
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_26, "Select a patient above.")),
                            (selectedPatient.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 2,
                                    class: (0, vue_2.normalizeClass)(["cal-status", patientStatus.value.tone])
                                }, [
                                    _cache[59] || (_cache[59] = (0, vue_2.createElementVNode)("span", { class: "cal-status-label" }, "Current Status", -1)),
                                    (0, vue_2.createElementVNode)("span", _hoisted_27, (0, vue_2.toDisplayString)(patientStatus.value.text), 1)
                                ], 2))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("section", _hoisted_28, [
                            _cache[62] || (_cache[62] = (0, vue_2.createElementVNode)("h3", { class: "cal-card-title" }, "Caregiver Info", -1)),
                            (selectedCaregiver.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_29, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_30, (0, vue_2.toDisplayString)(initials(selectedCaregiver.value.name)), 1),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)(selectedCaregiver.value.name), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)(selectedCaregiver.value.credential) + " · " + (0, vue_2.toDisplayString)(selectedCaregiver.value.specialty), 1)
                                    ])
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_33, "Select a caregiver above.")),
                            (selectedCaregiver.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 2,
                                    class: (0, vue_2.normalizeClass)(["cal-status", todaysWindows.value.length ? 'ok' : 'muted'])
                                }, [
                                    _cache[61] || (_cache[61] = (0, vue_2.createElementVNode)("span", { class: "cal-status-label" }, "Availability (today)", -1)),
                                    (0, vue_2.createElementVNode)("span", _hoisted_34, (0, vue_2.toDisplayString)(todaysWindows.value.length ? todaysWindows.value.join(', ') : 'None scheduled'), 1)
                                ], 2))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]),
                        (0, vue_2.createElementVNode)("section", _hoisted_35, [
                            _cache[68] || (_cache[68] = (0, vue_2.createElementVNode)("h3", { class: "cal-card-title" }, "Compatibility Check", -1)),
                            (0, vue_2.createElementVNode)("ul", _hoisted_36, [
                                (selectedCaregiver.value && selectedContext.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_37, [
                                        (0, vue_2.createElementVNode)("span", {
                                            class: (0, vue_2.normalizeClass)(["cal-dot", visitLine.value.tone])
                                        }, null, 2),
                                        (0, vue_2.createElementVNode)("span", null, [
                                            (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(selectedCaregiver.value.specialty || selectedCaregiver.value.credential), 1),
                                            (0, vue_2.createTextVNode)(" visit via " + (0, vue_2.toDisplayString)(selectedContext.value) + " is ", 1),
                                            (0, vue_2.createElementVNode)("strong", {
                                                class: (0, vue_2.normalizeClass)('t-' + visitLine.value.tone)
                                            }, (0, vue_2.toDisplayString)(visitLine.value.verdict), 3),
                                            _cache[63] || (_cache[63] = (0, vue_2.createTextVNode)(". ", -1))
                                        ])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(patientUnavailableToday.value, function (w, i) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                        key: 'u' + i
                                    }, [
                                        _cache[64] || (_cache[64] = (0, vue_2.createElementVNode)("span", { class: "cal-dot warn" }, null, -1)),
                                        (0, vue_2.createElementVNode)("span", null, [
                                            (0, vue_2.createElementVNode)("strong", null, "Patient " + (0, vue_2.toDisplayString)(w.hard ? 'unavailable' : 'occupied') + ":", 1),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(w.range) + " (" + (0, vue_2.toDisplayString)(w.label) + ")", 1)
                                        ])
                                    ]));
                                }), 128)),
                                (selectedPatient.value && patientUnavailableToday.value.length === 0)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_38, __spreadArray([], (_cache[65] || (_cache[65] = [
                                        (0, vue_2.createElementVNode)("span", { class: "cal-dot ok" }, null, -1),
                                        (0, vue_2.createElementVNode)("span", null, "Patient has no unavailable blocks today.", -1)
                                    ])), true)))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (parallelAllowed.value.length)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_39, [
                                        _cache[67] || (_cache[67] = (0, vue_2.createElementVNode)("span", { class: "cal-dot ok" }, null, -1)),
                                        (0, vue_2.createElementVNode)("span", null, [
                                            _cache[66] || (_cache[66] = (0, vue_2.createElementVNode)("strong", null, "Parallel visits allowed:", -1)),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(parallelAllowed.value.join(', ')), 1)
                                        ])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_40, [
                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                            (0, vue_2.createElementVNode)("h2", null, (0, vue_2.toDisplayString)(headerLabel.value), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: (0, vue_2.normalizeClass)({ active: view.value === 'week' }),
                                        onClick: _cache[5] || (_cache[5] = function ($event) { return (view.value = 'week'); })
                                    }, "Week", 2),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: (0, vue_2.normalizeClass)({ active: view.value === 'day' }),
                                        onClick: _cache[6] || (_cache[6] = function ($event) { return (view.value = 'day'); })
                                    }, "Day", 2),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: (0, vue_2.normalizeClass)({ active: view.value === 'month' }),
                                        onClick: _cache[7] || (_cache[7] = function ($event) { return (view.value = 'month'); })
                                    }, "Month", 2)
                                ]),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "nav-btn",
                                    onClick: goPrev
                                }, __spreadArray([], (_cache[69] || (_cache[69] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-left bi-chevron-left" }, null, -1)
                                ])), true)),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "nav-btn today-btn",
                                    onClick: goToday
                                }, "Today"),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "nav-btn",
                                    onClick: goNext
                                }, __spreadArray([], (_cache[70] || (_cache[70] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-right bi-chevron-right" }, null, -1)
                                ])), true))
                            ])
                        ]),
                        (!selectedPatientId.value || !selectedCaregiverId.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_44, __spreadArray([], (_cache[71] || (_cache[71] = [
                                (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-calendar2-week cal-empty-icon" }, null, -1),
                                (0, vue_2.createElementVNode)("p", null, "Select a patient and caregiver above to view their schedule.", -1)
                            ])), true)))
                            : (view.value === 'month')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_45, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_46, [
                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(WEEKDAY_NAMES, function (wd) {
                                            return (0, vue_2.createElementVNode)("div", {
                                                key: wd,
                                                class: "month-head-cell"
                                            }, (0, vue_2.toDisplayString)(wd), 1);
                                        }), 64))
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(monthCells.value, function (cell) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: cell.dateStr,
                                                class: (0, vue_2.normalizeClass)(["month-cell", { 'out-month': !cell.inMonth, today: cell.dateStr === (0, vue_2.unref)(todayStr) }]),
                                                onClick: function ($event) { return (jumpToDay(cell.dateStr)); }
                                            }, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_49, (0, vue_2.toDisplayString)(cell.dayNum), 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_50, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(cell.visible, function (apt) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                            key: apt.id,
                                                            class: (0, vue_2.normalizeClass)(["month-chip", apt.status])
                                                        }, (0, vue_2.toDisplayString)(formatTime(apt.time)) + " " + (0, vue_2.toDisplayString)(patientLabel(apt.patientId)), 3));
                                                    }), 128)),
                                                    (cell.overflow > 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_51, "+" + (0, vue_2.toDisplayString)(cell.overflow) + " more", 1))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ])
                                            ], 10, _hoisted_48));
                                        }), 128))
                                    ])
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_52, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "week-grid-head",
                                        style: (0, vue_2.normalizeStyle)(gridColumnsStyle.value)
                                    }, [
                                        _cache[72] || (_cache[72] = (0, vue_2.createElementVNode)("div", { class: "week-gutter" }, null, -1)),
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(gridDays.value, function (day) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: day.dateStr,
                                                class: (0, vue_2.normalizeClass)(["week-day-head", { today: day.dateStr === (0, vue_2.unref)(todayStr) }])
                                            }, [
                                                (0, vue_2.createElementVNode)("span", _hoisted_53, (0, vue_2.toDisplayString)(day.dayName), 1),
                                                (0, vue_2.createElementVNode)("span", _hoisted_54, (0, vue_2.toDisplayString)(day.dayNum), 1)
                                            ], 2));
                                        }), 128))
                                    ], 4),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: "week-grid-body",
                                        style: (0, vue_2.normalizeStyle)(gridColumnsStyle.value)
                                    }, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_55, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(HOURS), function (h) {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                    key: h,
                                                    class: "hour-label"
                                                }, (0, vue_2.toDisplayString)(formatHourLabel(h)), 1));
                                            }), 128))
                                        ]),
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(gridDays.value, function (day) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: day.dateStr,
                                                class: "week-day-col",
                                                onClick: function ($event) { return (onColumnClick(day, $event)); }
                                            }, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(HOURS), function (h) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                        key: h,
                                                        class: "hour-cell"
                                                    }));
                                                }), 128)),
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(eventsForDay(day.dateStr, day.date.getDay()), function (ev) {
                                                    var _a, _b;
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                        key: "".concat(ev.kind, "-").concat(ev.startMin, "-").concat((_b = (_a = ev.appointment) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ''),
                                                        class: (0, vue_2.normalizeClass)(["cal-event", ev.kind]),
                                                        style: (0, vue_2.normalizeStyle)(ev.style),
                                                        title: (ev.kind === 'scheduled' || ev.kind === 'other-caregiver') ? 'Click to view / manage' : ev.title,
                                                        onClick: (0, vue_2.withModifiers)(function ($event) { return ((ev.kind === 'scheduled' || ev.kind === 'other-caregiver') ? openVisitDetails(ev.appointment) : onColumnClick(day, $event, ev.startMin)); }, ["stop"])
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", _hoisted_58, (0, vue_2.toDisplayString)(ev.startLabel) + "–" + (0, vue_2.toDisplayString)(ev.endLabel), 1),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_59, (0, vue_2.toDisplayString)(ev.title), 1)
                                                    ], 14, _hoisted_57));
                                                }), 128))
                                            ], 8, _hoisted_56));
                                        }), 128))
                                    ], 4)
                                ])),
                        (view.value !== 'month')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_60, __spreadArray([], (_cache[73] || (_cache[73] = [
                                (0, vue_2.createStaticVNode)("<span data-v-16e5f8f6><i class=\"sw scheduled\" data-v-16e5f8f6></i> Scheduled visit</span><span data-v-16e5f8f6><i class=\"sw other-caregiver\" data-v-16e5f8f6></i> Other caregiver&#39;s visit</span><span data-v-16e5f8f6><i class=\"sw hard\" data-v-16e5f8f6></i> Patient unavailable</span><span data-v-16e5f8f6><i class=\"sw soft\" data-v-16e5f8f6></i> Patient occupied</span><span data-v-16e5f8f6><i class=\"sw cunavail\" data-v-16e5f8f6></i> Caregiver unavailable</span><span data-v-16e5f8f6><i class=\"sw open\" data-v-16e5f8f6></i> Open — click to book</span>", 6)
                            ])), true)))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                        default: (0, vue_2.withCtx)(function () {
                            var _a, _b, _c, _d;
                            return [
                                (bookingModalOpen.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        key: 0,
                                        class: "modal-overlay",
                                        onClick: _cache[34] || (_cache[34] = (0, vue_2.withModifiers)(function ($event) { return (bookingModalOpen.value = false); }, ["self"]))
                                    }, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_62, [
                                                (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(rescheduleTarget.value ? 'Reschedule Visit' : 'New Visit'), 1),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "modal-close",
                                                    onClick: _cache[8] || (_cache[8] = function ($event) { return (bookingModalOpen.value = false); })
                                                }, __spreadArray([], (_cache[74] || (_cache[74] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                                ])), true))
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_63, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_64, [
                                                    _cache[76] || (_cache[76] = (0, vue_2.createElementVNode)("label", null, "Patient", -1)),
                                                    (((_a = access.value) === null || _a === void 0 ? void 0 : _a.kind) === 'patient')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_65, [
                                                            (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(access.value.patientName), 1)
                                                        ]))
                                                        : (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("select", {
                                                            key: 1,
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((selectedPatientId).value = $event); }),
                                                            class: "pa-select"
                                                        }, [
                                                            _cache[75] || (_cache[75] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select a patient —", -1)),
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(patients.value, function (p) {
                                                                var _a, _b;
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                    key: (_a = p.psersonalID) !== null && _a !== void 0 ? _a : p.id,
                                                                    value: (_b = p.psersonalID) !== null && _b !== void 0 ? _b : p.id
                                                                }, (0, vue_2.toDisplayString)(p.firstName) + " " + (0, vue_2.toDisplayString)(p.lastName) + " — " + (0, vue_2.toDisplayString)(p.mrn), 9, _hoisted_66));
                                                            }), 128))
                                                        ], 512)), [
                                                            [vue_2.vModelSelect, selectedPatientId.value]
                                                        ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                                    (showCaregiverTypeSelector.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_68, [
                                                            _cache[78] || (_cache[78] = (0, vue_2.createElementVNode)("label", null, "Caregiver Type", -1)),
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((caregiverTypeSelection).value = $event); }),
                                                                class: "pa-select"
                                                            }, [
                                                                _cache[77] || (_cache[77] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select caregiver type —", -1)),
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(caregiverTypeGroups.value, function (group) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("optgroup", {
                                                                        key: group.label,
                                                                        label: group.label
                                                                    }, [
                                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.options, function (opt) {
                                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                                key: opt.value,
                                                                                value: opt.value
                                                                            }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_70));
                                                                        }), 128))
                                                                    ], 8, _hoisted_69));
                                                                }), 128))
                                                            ], 512), [
                                                                [vue_2.vModelSelect, caregiverTypeSelection.value]
                                                            ])
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[80] || (_cache[80] = (0, vue_2.createElementVNode)("label", null, "Caregiver", -1)),
                                                        (((_b = access.value) === null || _b === void 0 ? void 0 : _b.kind) === 'caregiver')
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_71, [
                                                                (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(((_c = selectedCaregiver.value) === null || _c === void 0 ? void 0 : _c.name) || 'You'), 1)
                                                            ]))
                                                            : (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("select", {
                                                                key: 1,
                                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((selectedCaregiverId).value = $event); }),
                                                                class: "pa-select"
                                                            }, [
                                                                _cache[79] || (_cache[79] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select a caregiver —", -1)),
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(caregiverOptions.value, function (c) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                        key: c.id,
                                                                        value: c.id
                                                                    }, (0, vue_2.toDisplayString)(c.name) + " — " + (0, vue_2.toDisplayString)(c.specialty || c.credential), 9, _hoisted_72));
                                                                }), 128))
                                                            ], 512)), [
                                                                [vue_2.vModelSelect, selectedCaregiverId.value]
                                                            ])
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                                    _cache[82] || (_cache[82] = (0, vue_2.createElementVNode)("label", null, "Context", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((selectedContext).value = $event); }),
                                                        class: "pa-select",
                                                        disabled: !selectedCaregiver.value
                                                    }, [
                                                        _cache[81] || (_cache[81] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select context —", -1)),
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(contextOptions.value, function (ctx) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                key: ctx,
                                                                value: ctx
                                                            }, (0, vue_2.toDisplayString)(ctx), 9, _hoisted_75));
                                                        }), 128))
                                                    ], 8, _hoisted_74), [
                                                        [vue_2.vModelSelect, selectedContext.value]
                                                    ])
                                                ]),
                                                (selectedCaregiver.value && selectedContext.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_76, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_77, [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_78, [
                                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(selectedCaregiver.value.specialty || selectedCaregiver.value.credential) + " visit type allowed:", 1),
                                                                (0, vue_2.createElementVNode)("strong", {
                                                                    class: (0, vue_2.normalizeClass)('t-' + visitLine.value.tone)
                                                                }, "[" + (0, vue_2.toDisplayString)(visitVerdictBadge.value) + "]", 3)
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_79, [
                                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(selectedContext.value) + " visits allowed:", 1),
                                                                (0, vue_2.createElementVNode)("strong", {
                                                                    class: (0, vue_2.normalizeClass)('t-' + visitLine.value.tone)
                                                                }, "[" + (0, vue_2.toDisplayString)(visitVerdictBadge.value) + "]", 3)
                                                            ])
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_80, [
                                                            (0, vue_2.createElementVNode)("label", _hoisted_81, [
                                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                    type: "checkbox",
                                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((showCompatDetails).value = $event); })
                                                                }, null, 512), [
                                                                    [vue_2.vModelCheckbox, showCompatDetails.value]
                                                                ]),
                                                                _cache[83] || (_cache[83] = (0, vue_2.createTextVNode)(" Show more Info ", -1))
                                                            ]),
                                                            (showCompatDetails.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_82, [
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_83, [
                                                                        (0, vue_2.createElementVNode)("span", {
                                                                            class: (0, vue_2.normalizeClass)(["cal-dot", visitLine.value.tone])
                                                                        }, null, 2),
                                                                        (0, vue_2.createElementVNode)("span", null, [
                                                                            (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(selectedCaregiver.value.specialty || selectedCaregiver.value.credential), 1),
                                                                            (0, vue_2.createTextVNode)(" visit via " + (0, vue_2.toDisplayString)(selectedContext.value) + " is ", 1),
                                                                            (0, vue_2.createElementVNode)("strong", {
                                                                                class: (0, vue_2.normalizeClass)('t-' + visitLine.value.tone)
                                                                            }, (0, vue_2.toDisplayString)(visitLine.value.verdict), 3),
                                                                            _cache[84] || (_cache[84] = (0, vue_2.createTextVNode)(". ", -1))
                                                                        ])
                                                                    ]),
                                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(patientUnavailableToday.value, function (w, i) {
                                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                            key: 'u' + i,
                                                                            class: "compat-line"
                                                                        }, [
                                                                            _cache[85] || (_cache[85] = (0, vue_2.createElementVNode)("span", { class: "cal-dot warn" }, null, -1)),
                                                                            (0, vue_2.createElementVNode)("span", null, [
                                                                                (0, vue_2.createElementVNode)("strong", null, "Patient " + (0, vue_2.toDisplayString)(w.hard ? 'unavailable' : 'occupied') + " today:", 1),
                                                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(w.range) + " (" + (0, vue_2.toDisplayString)(w.label) + ")", 1)
                                                                            ])
                                                                        ]));
                                                                    }), 128)),
                                                                    (parallelAllowed.value.length)
                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_84, [
                                                                            _cache[87] || (_cache[87] = (0, vue_2.createElementVNode)("span", { class: "cal-dot ok" }, null, -1)),
                                                                            (0, vue_2.createElementVNode)("span", null, [
                                                                                _cache[86] || (_cache[86] = (0, vue_2.createElementVNode)("strong", null, "Parallel visits allowed:", -1)),
                                                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(parallelAllowed.value.join(', ')), 1)
                                                                            ])
                                                                        ]))
                                                                        : (0, vue_2.createCommentVNode)("", true)
                                                                ]))
                                                                : (0, vue_2.createCommentVNode)("", true)
                                                        ])
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", _hoisted_85, [
                                                    _cache[90] || (_cache[90] = (0, vue_2.createElementVNode)("label", null, "Date", -1)),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_86, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_87, [
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                onClick: _cache[14] || (_cache[14] = function ($event) { return (miniMonthAnchor.value = shiftMonth(miniMonthAnchor.value, -1)); })
                                                            }, __spreadArray([], (_cache[88] || (_cache[88] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-left bi-chevron-left" }, null, -1)
                                                            ])), true)),
                                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(miniMonthLabel.value), 1),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                onClick: _cache[15] || (_cache[15] = function ($event) { return (miniMonthAnchor.value = shiftMonth(miniMonthAnchor.value, 1)); })
                                                            }, __spreadArray([], (_cache[89] || (_cache[89] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-chevron-right bi-chevron-right" }, null, -1)
                                                            ])), true))
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_88, [
                                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(WEEKDAY_NAMES, function (wd) {
                                                                return (0, vue_2.createElementVNode)("span", {
                                                                    key: wd,
                                                                    class: "mini-wd"
                                                                }, (0, vue_2.toDisplayString)(wd[0]), 1);
                                                            }), 64)),
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(miniMonthCells.value, function (cell) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                    type: "button",
                                                                    key: cell.dateStr,
                                                                    class: (0, vue_2.normalizeClass)(["mini-day", { 'out-month': !cell.inMonth, selected: cell.dateStr === bookingDate.value }]),
                                                                    onClick: function ($event) { return (selectBookingDate(cell.dateStr)); }
                                                                }, (0, vue_2.toDisplayString)(cell.dayNum), 11, _hoisted_89));
                                                            }), 128))
                                                        ])
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_90, [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[92] || (_cache[92] = (0, vue_2.createElementVNode)("label", null, "Start Time", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) { return ((bookingTime).value = $event); }),
                                                            class: "pa-select",
                                                            onChange: onBookingTimeSelected
                                                        }, [
                                                            _cache[91] || (_cache[91] = (0, vue_2.createElementVNode)("option", { value: "" }, "— Select —", -1)),
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(bookingSlots.value, function (slot) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                    key: slot.value,
                                                                    value: slot.value
                                                                }, (0, vue_2.toDisplayString)(slot.label), 9, _hoisted_91));
                                                            }), 128))
                                                        ], 544), [
                                                            [vue_2.vModelSelect, bookingTime.value]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _cache[93] || (_cache[93] = (0, vue_2.createElementVNode)("label", null, "Duration", -1)),
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) { return ((bookingDuration).value = $event); }),
                                                            class: "pa-select"
                                                        }, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(durationOptions.value, function (opt) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                    key: opt.value,
                                                                    value: opt.value
                                                                }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_92));
                                                            }), 128))
                                                        ], 512), [
                                                            [
                                                                vue_2.vModelSelect,
                                                                bookingDuration.value,
                                                                void 0,
                                                                { number: true }
                                                            ]
                                                        ])
                                                    ])
                                                ]),
                                                (showNoSlotsHint.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_93, [
                                                        _cache[94] || (_cache[94] = (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-info-circle-fill" }, null, -1)),
                                                        (0, vue_2.createTextVNode)(" No open times for " + (0, vue_2.toDisplayString)(((_d = selectedCaregiver.value) === null || _d === void 0 ? void 0 : _d.name) || 'this caregiver') + " on " + (0, vue_2.toDisplayString)(formattedBookingDate.value) + " — every slot is already booked or blocked by time off/availability hours. Try another date or caregiver. ", 1)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", _hoisted_94, [
                                                    _cache[95] || (_cache[95] = (0, vue_2.createElementVNode)("label", null, [
                                                        (0, vue_2.createTextVNode)("Reason "),
                                                        (0, vue_2.createElementVNode)("span", { class: "optional" }, "(optional)")
                                                    ], -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) { return ((bookingReason).value = $event); }),
                                                        placeholder: "e.g. Follow-up, Wound check"
                                                    }, null, 512), [
                                                        [vue_2.vModelText, bookingReason.value]
                                                    ])
                                                ]),
                                                (!rescheduleTarget.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_95, [
                                                        _cache[100] || (_cache[100] = (0, vue_2.createElementVNode)("label", null, "Recurrence", -1)),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_96, [
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                class: (0, vue_2.normalizeClass)({ active: recurrenceMode.value === 'none' }),
                                                                onClick: _cache[19] || (_cache[19] = function ($event) { return (recurrenceMode.value = 'none'); })
                                                            }, "One-time", 2),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                class: (0, vue_2.normalizeClass)({ active: recurrenceMode.value === 'weekly' }),
                                                                onClick: _cache[20] || (_cache[20] = function ($event) { return (recurrenceMode.value = 'weekly'); })
                                                            }, "Repeats weekly", 2),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                class: (0, vue_2.normalizeClass)({ active: recurrenceMode.value === 'daily' }),
                                                                onClick: _cache[21] || (_cache[21] = function ($event) { return (recurrenceMode.value = 'daily'); })
                                                            }, "Repeats daily", 2)
                                                        ]),
                                                        (recurrenceMode.value !== 'none')
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                (recurrenceMode.value === 'weekly')
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_97, [
                                                                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(RECURRENCE_DAY_OPTIONS, function (d) {
                                                                            return (0, vue_2.createElementVNode)("button", {
                                                                                key: d.value,
                                                                                type: "button",
                                                                                class: (0, vue_2.normalizeClass)(["recurrence-day-chip", { active: recurrenceDays.value.includes(d.value) }]),
                                                                                onClick: function ($event) { return (toggleRecurrenceDay(d.value)); }
                                                                            }, (0, vue_2.toDisplayString)(d.label), 11, _hoisted_98);
                                                                        }), 64))
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_99, [
                                                                    (0, vue_2.createElementVNode)("label", _hoisted_100, [
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            type: "radio",
                                                                            value: "count",
                                                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) { return ((recurrenceEndType).value = $event); })
                                                                        }, null, 512), [
                                                                            [vue_2.vModelRadio, recurrenceEndType.value]
                                                                        ]),
                                                                        _cache[96] || (_cache[96] = (0, vue_2.createTextVNode)(" End after ", -1)),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            type: "number",
                                                                            min: "1",
                                                                            max: 180,
                                                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) { return ((recurrenceEndCount).value = $event); }),
                                                                            class: "recurrence-end-input",
                                                                            disabled: recurrenceEndType.value !== 'count'
                                                                        }, null, 8, _hoisted_101), [
                                                                            [
                                                                                vue_2.vModelText,
                                                                                recurrenceEndCount.value,
                                                                                void 0,
                                                                                { number: true }
                                                                            ]
                                                                        ]),
                                                                        _cache[97] || (_cache[97] = (0, vue_2.createTextVNode)(" visits ", -1))
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("label", _hoisted_102, [
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            type: "radio",
                                                                            value: "date",
                                                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) { return ((recurrenceEndType).value = $event); })
                                                                        }, null, 512), [
                                                                            [vue_2.vModelRadio, recurrenceEndType.value]
                                                                        ]),
                                                                        _cache[98] || (_cache[98] = (0, vue_2.createTextVNode)(" End on ", -1)),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            type: "date",
                                                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) { return ((recurrenceEndDate).value = $event); }),
                                                                            class: "recurrence-end-input",
                                                                            disabled: recurrenceEndType.value !== 'date'
                                                                        }, null, 8, _hoisted_103), [
                                                                            [vue_2.vModelText, recurrenceEndDate.value]
                                                                        ])
                                                                    ])
                                                                ]),
                                                                (seriesPreview.value.length)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_104, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_105, [
                                                                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(seriesPreviewSummary.value.total) + " visits: " + (0, vue_2.toDisplayString)(seriesPreviewSummary.value.allowed) + " allowed", 1),
                                                                            (seriesPreviewSummary.value.conditional)
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_106, ", " + (0, vue_2.toDisplayString)(seriesPreviewSummary.value.conditional) + " conditional", 1))
                                                                                : (0, vue_2.createCommentVNode)("", true),
                                                                            (seriesPreviewSummary.value.blocked)
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_107, ", " + (0, vue_2.toDisplayString)(seriesPreviewSummary.value.blocked) + " blocked (will be skipped)", 1))
                                                                                : (0, vue_2.createCommentVNode)("", true),
                                                                            _cache[99] || (_cache[99] = (0, vue_2.createTextVNode)(". ", -1))
                                                                        ]),
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_108, [
                                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(seriesPreview.value, function (occ) {
                                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                                    key: occ.date,
                                                                                    class: (0, vue_2.normalizeClass)(["series-preview-chip", occ.decision]),
                                                                                    title: occ.reasons.join(' ')
                                                                                }, (0, vue_2.toDisplayString)(formatDateShort(occ.date)), 11, _hoisted_109));
                                                                            }), 128))
                                                                        ])
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ], 64))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (bookingDate.value && bookingTime.value && recurrenceMode.value === 'none')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                        key: 3,
                                                        class: (0, vue_2.normalizeClass)(["viability-panel", viability.value.decision])
                                                    }, [
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: (0, vue_2.normalizeClass)(["glyphicon", viabilityIcon(viability.value.decision)])
                                                        }, null, 2),
                                                        (0, vue_2.createElementVNode)("div", null, [
                                                            (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(viabilityLabel(viability.value.decision)), 1),
                                                            (viability.value.reasons.length)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", _hoisted_110, [
                                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(viability.value.reasons, function (r) {
                                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: r }, (0, vue_2.toDisplayString)(r), 1));
                                                                    }), 128))
                                                                ]))
                                                                : (0, vue_2.createCommentVNode)("", true)
                                                        ])
                                                    ], 2))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", _hoisted_111, [
                                                    (0, vue_2.createElementVNode)("label", _hoisted_112, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "checkbox",
                                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = function ($event) { return ((notifyOn).value = $event); })
                                                        }, null, 512), [
                                                            [vue_2.vModelCheckbox, notifyOn.value]
                                                        ]),
                                                        (0, vue_2.createTextVNode)(" Notify " + (0, vue_2.toDisplayString)(rescheduleTarget.value ? 'of this change' : 'patient / caregiver'), 1)
                                                    ]),
                                                    (notifyOn.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_113, [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    type: "button",
                                                                    class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyPatient.value }]),
                                                                    onClick: _cache[27] || (_cache[27] = function ($event) { return (notifyPatient.value = !notifyPatient.value); })
                                                                }, __spreadArray([], (_cache[101] || (_cache[101] = [
                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-fill" }, null, -1),
                                                                    (0, vue_2.createTextVNode)(" Patient ", -1)
                                                                ])), true), 2),
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    type: "button",
                                                                    class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyCaregiver.value }]),
                                                                    onClick: _cache[28] || (_cache[28] = function ($event) { return (notifyCaregiver.value = !notifyCaregiver.value); })
                                                                }, __spreadArray([], (_cache[102] || (_cache[102] = [
                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-badge-fill" }, null, -1),
                                                                    (0, vue_2.createTextVNode)(" Caregiver ", -1)
                                                                ])), true), 2),
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    type: "button",
                                                                    class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyGroups.value }]),
                                                                    onClick: _cache[29] || (_cache[29] = function ($event) { return (toggleNotifyGroups()); })
                                                                }, __spreadArray([], (_cache[103] || (_cache[103] = [
                                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-people-fill" }, null, -1),
                                                                    (0, vue_2.createTextVNode)(" Groups ", -1)
                                                                ])), true), 2)
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_114, [
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    type: "button",
                                                                    class: (0, vue_2.normalizeClass)({ active: notifyMethod.value === 'sms' }),
                                                                    onClick: _cache[30] || (_cache[30] = function ($event) { return (notifyMethod.value = 'sms'); })
                                                                }, "SMS", 2),
                                                                (0, vue_2.createElementVNode)("button", {
                                                                    type: "button",
                                                                    class: (0, vue_2.normalizeClass)({ active: notifyMethod.value === 'email' }),
                                                                    onClick: _cache[31] || (_cache[31] = function ($event) { return (notifyMethod.value = 'email'); })
                                                                }, "Email", 2)
                                                            ]),
                                                            (notifyGroups.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_115, [
                                                                    _cache[105] || (_cache[105] = (0, vue_2.createElementVNode)("span", { class: "group-select-label" }, "Patient Groups", -1)),
                                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                        multiple: "",
                                                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = function ($event) { return ((selectedGroupMembers).value = $event); }),
                                                                        class: "group-select"
                                                                    }, [
                                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(groupOptions.value, function (group) {
                                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("optgroup", {
                                                                                key: group.groupId,
                                                                                label: group.groupName
                                                                            }, [
                                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.members, function (member) {
                                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                                        key: member.pid,
                                                                                        value: member.email
                                                                                    }, (0, vue_2.toDisplayString)(member.patientName), 9, _hoisted_117));
                                                                                }), 128))
                                                                            ], 8, _hoisted_116));
                                                                        }), 128)),
                                                                        _cache[104] || (_cache[104] = (0, vue_2.createElementVNode)("optgroup", { label: "All Group Members" }, [
                                                                            (0, vue_2.createElementVNode)("option", { value: "All" }, "All Members")
                                                                        ], -1))
                                                                    ], 512), [
                                                                        [vue_2.vModelSelect, selectedGroupMembers.value]
                                                                    ])
                                                                ]))
                                                                : (0, vue_2.createCommentVNode)("", true)
                                                        ], 64))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]),
                                                (bookingError.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_118, (0, vue_2.toDisplayString)(bookingError.value), 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_119, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-cancel",
                                                    onClick: _cache[33] || (_cache[33] = function ($event) { return (bookingModalOpen.value = false); })
                                                }, "Cancel"),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-save",
                                                    disabled: !canConfirmBooking.value || savingBooking.value,
                                                    onClick: confirmBooking
                                                }, [
                                                    (savingBooking.value)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_121))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_122)),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(confirmButtonLabel.value), 1)
                                                ], 8, _hoisted_120)
                                            ])
                                        ])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ];
                        }, undefined, true),
                        _: 1
                    })
                ])),
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                    (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (detailsModalOpen.value && detailsVisit.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 0,
                                    class: "modal-overlay",
                                    onClick: _cache[47] || (_cache[47] = (0, vue_2.withModifiers)(function ($event) { return (detailsModalOpen.value = false); }, ["self"]))
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_123, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_124, [
                                            _cache[107] || (_cache[107] = (0, vue_2.createElementVNode)("h3", null, "Visit Details", -1)),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "modal-close",
                                                onClick: _cache[35] || (_cache[35] = function ($event) { return (detailsModalOpen.value = false); })
                                            }, __spreadArray([], (_cache[106] || (_cache[106] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                            ])), true))
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_125, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_126, [
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[108] || (_cache[108] = (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Patient", -1)),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_127, (0, vue_2.toDisplayString)(patientLabel(detailsVisit.value.patientId)), 1)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[109] || (_cache[109] = (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Caregiver", -1)),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_128, (0, vue_2.toDisplayString)(caregiverNameById(detailsVisit.value.providerId)), 1)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[110] || (_cache[110] = (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Date", -1)),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_129, (0, vue_2.toDisplayString)(formatDateShort(detailsVisit.value.date)) + " · " + (0, vue_2.toDisplayString)(formatTime(detailsVisit.value.time)), 1)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[111] || (_cache[111] = (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Context", -1)),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_130, (0, vue_2.toDisplayString)(detailsVisit.value.meetingType), 1)
                                                ]),
                                                (detailsVisit.value.reason)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_131, [
                                                        _cache[112] || (_cache[112] = (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Reason", -1)),
                                                        (0, vue_2.createElementVNode)("span", _hoisted_132, (0, vue_2.toDisplayString)(detailsVisit.value.reason), 1)
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    _cache[113] || (_cache[113] = (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Status", -1)),
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(["bs-value status-pill", detailsVisit.value.status])
                                                    }, (0, vue_2.toDisplayString)(detailsVisit.value.status), 3)
                                                ]),
                                                (detailsVisit.value.seriesId)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_133, __spreadArray([], (_cache[114] || (_cache[114] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "bs-label" }, "Series", -1),
                                                        (0, vue_2.createElementVNode)("span", { class: "bs-value" }, [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-arrow-repeat" }),
                                                            (0, vue_2.createTextVNode)(" Part of a recurring series")
                                                        ], -1)
                                                    ])), true)))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]),
                                            (scopeChoiceOpen.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_134, [
                                                    (0, vue_2.createElementVNode)("p", _hoisted_135, (0, vue_2.toDisplayString)(scopeChoiceOpen.value === 'cancel' ? 'Cancel which visits?' : 'Reschedule which visits?'), 1),
                                                    (0, vue_2.createElementVNode)("label", _hoisted_136, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "radio",
                                                            value: "this",
                                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = function ($event) { return ((scopeChoice).value = $event); })
                                                        }, null, 512), [
                                                            [vue_2.vModelRadio, scopeChoice.value]
                                                        ]),
                                                        _cache[115] || (_cache[115] = (0, vue_2.createTextVNode)(" This visit only", -1))
                                                    ]),
                                                    (0, vue_2.createElementVNode)("label", _hoisted_137, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "radio",
                                                            value: "following",
                                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = function ($event) { return ((scopeChoice).value = $event); })
                                                        }, null, 512), [
                                                            [vue_2.vModelRadio, scopeChoice.value]
                                                        ]),
                                                        _cache[116] || (_cache[116] = (0, vue_2.createTextVNode)(" This and following visits", -1))
                                                    ]),
                                                    (0, vue_2.createElementVNode)("label", _hoisted_138, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            type: "radio",
                                                            value: "series",
                                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = function ($event) { return ((scopeChoice).value = $event); })
                                                        }, null, 512), [
                                                            [vue_2.vModelRadio, scopeChoice.value]
                                                        ]),
                                                        _cache[117] || (_cache[117] = (0, vue_2.createTextVNode)(" The entire series", -1))
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_139, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "btn-cancel",
                                                            onClick: _cache[39] || (_cache[39] = function ($event) { return (scopeChoiceOpen.value = null); })
                                                        }, "Back"),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "btn-save",
                                                            disabled: savingBooking.value,
                                                            onClick: confirmScopedAction
                                                        }, "Continue", 8, _hoisted_140)
                                                    ])
                                                ]))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_141, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "btn-cancel-visit",
                                                            disabled: savingBooking.value,
                                                            onClick: startCancelVisit
                                                        }, __spreadArray([], (_cache[118] || (_cache[118] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove-circle" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" Cancel Visit ", -1)
                                                        ])), true), 8, _hoisted_142),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "btn-reschedule",
                                                            disabled: savingBooking.value,
                                                            onClick: startReschedule
                                                        }, __spreadArray([], (_cache[119] || (_cache[119] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-arrow-repeat" }, null, -1),
                                                            (0, vue_2.createTextVNode)(" Reschedule ", -1)
                                                        ])), true), 8, _hoisted_143)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_144, [
                                                        (0, vue_2.createElementVNode)("label", _hoisted_145, [
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                type: "checkbox",
                                                                "onUpdate:modelValue": _cache[40] || (_cache[40] = function ($event) { return ((notifyOn).value = $event); })
                                                            }, null, 512), [
                                                                [vue_2.vModelCheckbox, notifyOn.value]
                                                            ]),
                                                            _cache[120] || (_cache[120] = (0, vue_2.createTextVNode)(" Notify of this change ", -1))
                                                        ]),
                                                        (notifyOn.value)
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_146, [
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyPatient.value }]),
                                                                        onClick: _cache[41] || (_cache[41] = function ($event) { return (notifyPatient.value = !notifyPatient.value); })
                                                                    }, __spreadArray([], (_cache[121] || (_cache[121] = [
                                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-fill" }, null, -1),
                                                                        (0, vue_2.createTextVNode)(" Patient ", -1)
                                                                    ])), true), 2),
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyCaregiver.value }]),
                                                                        onClick: _cache[42] || (_cache[42] = function ($event) { return (notifyCaregiver.value = !notifyCaregiver.value); })
                                                                    }, __spreadArray([], (_cache[122] || (_cache[122] = [
                                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-badge-fill" }, null, -1),
                                                                        (0, vue_2.createTextVNode)(" Caregiver ", -1)
                                                                    ])), true), 2),
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: (0, vue_2.normalizeClass)(["notify-chip", { active: notifyGroups.value }]),
                                                                        onClick: _cache[43] || (_cache[43] = function ($event) { return (toggleNotifyGroups()); })
                                                                    }, __spreadArray([], (_cache[123] || (_cache[123] = [
                                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-people-fill" }, null, -1),
                                                                        (0, vue_2.createTextVNode)(" Groups ", -1)
                                                                    ])), true), 2)
                                                                ]),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_147, [
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: (0, vue_2.normalizeClass)({ active: notifyMethod.value === 'sms' }),
                                                                        onClick: _cache[44] || (_cache[44] = function ($event) { return (notifyMethod.value = 'sms'); })
                                                                    }, "SMS", 2),
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        type: "button",
                                                                        class: (0, vue_2.normalizeClass)({ active: notifyMethod.value === 'email' }),
                                                                        onClick: _cache[45] || (_cache[45] = function ($event) { return (notifyMethod.value = 'email'); })
                                                                    }, "Email", 2)
                                                                ]),
                                                                (notifyGroups.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_148, [
                                                                        _cache[125] || (_cache[125] = (0, vue_2.createElementVNode)("span", { class: "group-select-label" }, "Patient Groups", -1)),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                            multiple: "",
                                                                            "onUpdate:modelValue": _cache[46] || (_cache[46] = function ($event) { return ((selectedGroupMembers).value = $event); }),
                                                                            class: "group-select"
                                                                        }, [
                                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(groupOptions.value, function (group) {
                                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("optgroup", {
                                                                                    key: group.groupId,
                                                                                    label: group.groupName
                                                                                }, [
                                                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(group.members, function (member) {
                                                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                                            key: member.pid,
                                                                                            value: member.email
                                                                                        }, (0, vue_2.toDisplayString)(member.patientName), 9, _hoisted_150));
                                                                                    }), 128))
                                                                                ], 8, _hoisted_149));
                                                                            }), 128)),
                                                                            _cache[124] || (_cache[124] = (0, vue_2.createElementVNode)("optgroup", { label: "All Group Members" }, [
                                                                                (0, vue_2.createElementVNode)("option", { value: "All" }, "All Members")
                                                                            ], -1))
                                                                        ], 512), [
                                                                            [vue_2.vModelSelect, selectedGroupMembers.value]
                                                                        ])
                                                                    ]))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ], 64))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ])
                                                ], 64))
                                        ])
                                    ])
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]; }, undefined, true),
                        _: 1
                    })
                ])),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "toast" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (toast.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_151, [
                                _cache[126] || (_cache[126] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle bi-check-circle" }, null, -1)),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(toast.value), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]; }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
